var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var _selfieSegmentation, _newCanvas, _context, _selfieSegmentation2, _newCanvas2, _context2, _imageBackgroundTransformer, _simpleBackgroundTrasnformer;
const BROWSER_ALIASES_MAP = {
  "Amazon Silk": "amazon_silk",
  "Android Browser": "android",
  Bada: "bada",
  BlackBerry: "blackberry",
  Chrome: "chrome",
  Chromium: "chromium",
  Electron: "electron",
  Epiphany: "epiphany",
  Firefox: "firefox",
  Focus: "focus",
  Generic: "generic",
  "Google Search": "google_search",
  Googlebot: "googlebot",
  "Internet Explorer": "ie",
  "K-Meleon": "k_meleon",
  Maxthon: "maxthon",
  "Microsoft Edge": "edge",
  "MZ Browser": "mz",
  "NAVER Whale Browser": "naver",
  Opera: "opera",
  "Opera Coast": "opera_coast",
  PhantomJS: "phantomjs",
  Puffin: "puffin",
  QupZilla: "qupzilla",
  QQ: "qq",
  QQLite: "qqlite",
  Safari: "safari",
  Sailfish: "sailfish",
  "Samsung Internet for Android": "samsung_internet",
  SeaMonkey: "seamonkey",
  Sleipnir: "sleipnir",
  Swing: "swing",
  Tizen: "tizen",
  "UC Browser": "uc",
  Vivaldi: "vivaldi",
  "WebOS Browser": "webos",
  WeChat: "wechat",
  "Yandex Browser": "yandex",
  Roku: "roku"
};
const BROWSER_MAP = {
  amazon_silk: "Amazon Silk",
  android: "Android Browser",
  bada: "Bada",
  blackberry: "BlackBerry",
  chrome: "Chrome",
  chromium: "Chromium",
  electron: "Electron",
  epiphany: "Epiphany",
  firefox: "Firefox",
  focus: "Focus",
  generic: "Generic",
  googlebot: "Googlebot",
  google_search: "Google Search",
  ie: "Internet Explorer",
  k_meleon: "K-Meleon",
  maxthon: "Maxthon",
  edge: "Microsoft Edge",
  mz: "MZ Browser",
  naver: "NAVER Whale Browser",
  opera: "Opera",
  opera_coast: "Opera Coast",
  phantomjs: "PhantomJS",
  puffin: "Puffin",
  qupzilla: "QupZilla",
  qq: "QQ Browser",
  qqlite: "QQ Browser Lite",
  safari: "Safari",
  sailfish: "Sailfish",
  samsung_internet: "Samsung Internet for Android",
  seamonkey: "SeaMonkey",
  sleipnir: "Sleipnir",
  swing: "Swing",
  tizen: "Tizen",
  uc: "UC Browser",
  vivaldi: "Vivaldi",
  webos: "WebOS Browser",
  wechat: "WeChat",
  yandex: "Yandex Browser"
};
const PLATFORMS_MAP = {
  tablet: "tablet",
  mobile: "mobile",
  desktop: "desktop",
  tv: "tv"
};
const OS_MAP = {
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MacOS: "macOS",
  iOS: "iOS",
  Android: "Android",
  WebOS: "WebOS",
  BlackBerry: "BlackBerry",
  Bada: "Bada",
  Tizen: "Tizen",
  Linux: "Linux",
  ChromeOS: "Chrome OS",
  PlayStation4: "PlayStation 4",
  Roku: "Roku"
};
const ENGINE_MAP = {
  EdgeHTML: "EdgeHTML",
  Blink: "Blink",
  Trident: "Trident",
  Presto: "Presto",
  Gecko: "Gecko",
  WebKit: "WebKit"
};
class Utils {
  static getFirstMatch(regexp, ua) {
    const match = ua.match(regexp);
    return match && match.length > 0 && match[1] || "";
  }
  static getSecondMatch(regexp, ua) {
    const match = ua.match(regexp);
    return match && match.length > 1 && match[2] || "";
  }
  static matchAndReturnConst(regexp, ua, _const) {
    if (regexp.test(ua)) {
      return _const;
    }
    return void 0;
  }
  static getWindowsVersionName(version) {
    switch (version) {
      case "NT":
        return "NT";
      case "XP":
        return "XP";
      case "NT 5.0":
        return "2000";
      case "NT 5.1":
        return "XP";
      case "NT 5.2":
        return "2003";
      case "NT 6.0":
        return "Vista";
      case "NT 6.1":
        return "7";
      case "NT 6.2":
        return "8";
      case "NT 6.3":
        return "8.1";
      case "NT 10.0":
        return "10";
      default:
        return void 0;
    }
  }
  static getMacOSVersionName(version) {
    const v = version.split(".").splice(0, 2).map((s) => parseInt(s, 10) || 0);
    v.push(0);
    if (v[0] !== 10)
      return void 0;
    switch (v[1]) {
      case 5:
        return "Leopard";
      case 6:
        return "Snow Leopard";
      case 7:
        return "Lion";
      case 8:
        return "Mountain Lion";
      case 9:
        return "Mavericks";
      case 10:
        return "Yosemite";
      case 11:
        return "El Capitan";
      case 12:
        return "Sierra";
      case 13:
        return "High Sierra";
      case 14:
        return "Mojave";
      case 15:
        return "Catalina";
      default:
        return void 0;
    }
  }
  static getAndroidVersionName(version) {
    const v = version.split(".").splice(0, 2).map((s) => parseInt(s, 10) || 0);
    v.push(0);
    if (v[0] === 1 && v[1] < 5)
      return void 0;
    if (v[0] === 1 && v[1] < 6)
      return "Cupcake";
    if (v[0] === 1 && v[1] >= 6)
      return "Donut";
    if (v[0] === 2 && v[1] < 2)
      return "Eclair";
    if (v[0] === 2 && v[1] === 2)
      return "Froyo";
    if (v[0] === 2 && v[1] > 2)
      return "Gingerbread";
    if (v[0] === 3)
      return "Honeycomb";
    if (v[0] === 4 && v[1] < 1)
      return "Ice Cream Sandwich";
    if (v[0] === 4 && v[1] < 4)
      return "Jelly Bean";
    if (v[0] === 4 && v[1] >= 4)
      return "KitKat";
    if (v[0] === 5)
      return "Lollipop";
    if (v[0] === 6)
      return "Marshmallow";
    if (v[0] === 7)
      return "Nougat";
    if (v[0] === 8)
      return "Oreo";
    if (v[0] === 9)
      return "Pie";
    return void 0;
  }
  static getVersionPrecision(version) {
    return version.split(".").length;
  }
  static compareVersions(versionA, versionB, isLoose = false) {
    const versionAPrecision = Utils.getVersionPrecision(versionA);
    const versionBPrecision = Utils.getVersionPrecision(versionB);
    let precision = Math.max(versionAPrecision, versionBPrecision);
    let lastPrecision = 0;
    const chunks = Utils.map([versionA, versionB], (version) => {
      const delta = precision - Utils.getVersionPrecision(version);
      const _version = version + new Array(delta + 1).join(".0");
      return Utils.map(_version.split("."), (chunk) => new Array(20 - chunk.length).join("0") + chunk).reverse();
    });
    if (isLoose) {
      lastPrecision = precision - Math.min(versionAPrecision, versionBPrecision);
    }
    precision -= 1;
    while (precision >= lastPrecision) {
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === lastPrecision) {
          return 0;
        }
        precision -= 1;
      } else if (chunks[0][precision] < chunks[1][precision]) {
        return -1;
      }
    }
    return void 0;
  }
  static map(arr, iterator) {
    const result = [];
    let i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i += 1) {
      result.push(iterator(arr[i]));
    }
    return result;
  }
  static find(arr, predicate) {
    let i;
    let l;
    if (Array.prototype.find) {
      return Array.prototype.find.call(arr, predicate);
    }
    for (i = 0, l = arr.length; i < l; i += 1) {
      const value = arr[i];
      if (predicate(value, i)) {
        return value;
      }
    }
    return void 0;
  }
  static assign(obj, ...assigners) {
    const result = obj;
    let i;
    let l;
    if (Object.assign) {
      return Object.assign(obj, ...assigners);
    }
    for (i = 0, l = assigners.length; i < l; i += 1) {
      const assigner = assigners[i];
      if (typeof assigner === "object" && assigner !== null) {
        const keys = Object.keys(assigner);
        keys.forEach((key) => {
          result[key] = assigner[key];
        });
      }
    }
    return obj;
  }
  static getBrowserAlias(browserName) {
    return BROWSER_ALIASES_MAP[browserName];
  }
  static getBrowserTypeByAlias(browserAlias) {
    return BROWSER_MAP[browserAlias] || "";
  }
}
const commonVersionIdentifier = /version\/(\d+(\.?_?\d+)+)/i;
const browsersList = [
  {
    test: [/googlebot/i],
    describe(ua) {
      const browser = {
        name: "Googlebot"
      };
      const version = Utils.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/opera/i],
    describe(ua) {
      const browser = {
        name: "Opera"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/opr\/|opios/i],
    describe(ua) {
      const browser = {
        name: "Opera"
      };
      const version = Utils.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/SamsungBrowser/i],
    describe(ua) {
      const browser = {
        name: "Samsung Internet for Android"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/Whale/i],
    describe(ua) {
      const browser = {
        name: "NAVER Whale Browser"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/MZBrowser/i],
    describe(ua) {
      const browser = {
        name: "MZ Browser"
      };
      const version = Utils.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/focus/i],
    describe(ua) {
      const browser = {
        name: "Focus"
      };
      const version = Utils.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/swing/i],
    describe(ua) {
      const browser = {
        name: "Swing"
      };
      const version = Utils.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/coast/i],
    describe(ua) {
      const browser = {
        name: "Opera Coast"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/opt\/\d+(?:.?_?\d+)+/i],
    describe(ua) {
      const browser = {
        name: "Opera Touch"
      };
      const version = Utils.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/yabrowser/i],
    describe(ua) {
      const browser = {
        name: "Yandex Browser"
      };
      const version = Utils.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/ucbrowser/i],
    describe(ua) {
      const browser = {
        name: "UC Browser"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/Maxthon|mxios/i],
    describe(ua) {
      const browser = {
        name: "Maxthon"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/epiphany/i],
    describe(ua) {
      const browser = {
        name: "Epiphany"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/puffin/i],
    describe(ua) {
      const browser = {
        name: "Puffin"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/sleipnir/i],
    describe(ua) {
      const browser = {
        name: "Sleipnir"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/k-meleon/i],
    describe(ua) {
      const browser = {
        name: "K-Meleon"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/micromessenger/i],
    describe(ua) {
      const browser = {
        name: "WeChat"
      };
      const version = Utils.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/qqbrowser/i],
    describe(ua) {
      const browser = {
        name: /qqbrowserlite/i.test(ua) ? "QQ Browser Lite" : "QQ Browser"
      };
      const version = Utils.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/msie|trident/i],
    describe(ua) {
      const browser = {
        name: "Internet Explorer"
      };
      const version = Utils.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/\sedg\//i],
    describe(ua) {
      const browser = {
        name: "Microsoft Edge"
      };
      const version = Utils.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/edg([ea]|ios)/i],
    describe(ua) {
      const browser = {
        name: "Microsoft Edge"
      };
      const version = Utils.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/vivaldi/i],
    describe(ua) {
      const browser = {
        name: "Vivaldi"
      };
      const version = Utils.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/seamonkey/i],
    describe(ua) {
      const browser = {
        name: "SeaMonkey"
      };
      const version = Utils.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/sailfish/i],
    describe(ua) {
      const browser = {
        name: "Sailfish"
      };
      const version = Utils.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/silk/i],
    describe(ua) {
      const browser = {
        name: "Amazon Silk"
      };
      const version = Utils.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/phantom/i],
    describe(ua) {
      const browser = {
        name: "PhantomJS"
      };
      const version = Utils.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/slimerjs/i],
    describe(ua) {
      const browser = {
        name: "SlimerJS"
      };
      const version = Utils.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(ua) {
      const browser = {
        name: "BlackBerry"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/(web|hpw)[o0]s/i],
    describe(ua) {
      const browser = {
        name: "WebOS Browser"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/bada/i],
    describe(ua) {
      const browser = {
        name: "Bada"
      };
      const version = Utils.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/tizen/i],
    describe(ua) {
      const browser = {
        name: "Tizen"
      };
      const version = Utils.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/qupzilla/i],
    describe(ua) {
      const browser = {
        name: "QupZilla"
      };
      const version = Utils.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/firefox|iceweasel|fxios/i],
    describe(ua) {
      const browser = {
        name: "Firefox"
      };
      const version = Utils.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/electron/i],
    describe(ua) {
      const browser = {
        name: "Electron"
      };
      const version = Utils.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/MiuiBrowser/i],
    describe(ua) {
      const browser = {
        name: "Miui"
      };
      const version = Utils.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/chromium/i],
    describe(ua) {
      const browser = {
        name: "Chromium"
      };
      const version = Utils.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/chrome|crios|crmo/i],
    describe(ua) {
      const browser = {
        name: "Chrome"
      };
      const version = Utils.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/GSA/i],
    describe(ua) {
      const browser = {
        name: "Google Search"
      };
      const version = Utils.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test(parser) {
      const notLikeAndroid = !parser.test(/like android/i);
      const butAndroid = parser.test(/android/i);
      return notLikeAndroid && butAndroid;
    },
    describe(ua) {
      const browser = {
        name: "Android Browser"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/playstation 4/i],
    describe(ua) {
      const browser = {
        name: "PlayStation 4"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/safari|applewebkit/i],
    describe(ua) {
      const browser = {
        name: "Safari"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser.version = version;
      }
      return browser;
    }
  },
  {
    test: [/.*/i],
    describe(ua) {
      const regexpWithoutDeviceSpec = /^(.*)\/(.*) /;
      const regexpWithDeviceSpec = /^(.*)\/(.*)[ \t]\((.*)/;
      const hasDeviceSpec = ua.search("\\(") !== -1;
      const regexp = hasDeviceSpec ? regexpWithDeviceSpec : regexpWithoutDeviceSpec;
      return {
        name: Utils.getFirstMatch(regexp, ua),
        version: Utils.getSecondMatch(regexp, ua)
      };
    }
  }
];
var osParsersList = [
  {
    test: [/Roku\/DVP/],
    describe(ua) {
      const version = Utils.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, ua);
      return {
        name: OS_MAP.Roku,
        version
      };
    }
  },
  {
    test: [/windows phone/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.WindowsPhone,
        version
      };
    }
  },
  {
    test: [/windows /i],
    describe(ua) {
      const version = Utils.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, ua);
      const versionName = Utils.getWindowsVersionName(version);
      return {
        name: OS_MAP.Windows,
        version,
        versionName
      };
    }
  },
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe(ua) {
      const result = {
        name: OS_MAP.iOS
      };
      const version = Utils.getSecondMatch(/(Version\/)(\d[\d.]+)/, ua);
      if (version) {
        result.version = version;
      }
      return result;
    }
  },
  {
    test: [/macintosh/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, ua).replace(/[_\s]/g, ".");
      const versionName = Utils.getMacOSVersionName(version);
      const os = {
        name: OS_MAP.MacOS,
        version
      };
      if (versionName) {
        os.versionName = versionName;
      }
      return os;
    }
  },
  {
    test: [/(ipod|iphone|ipad)/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, ua).replace(/[_\s]/g, ".");
      return {
        name: OS_MAP.iOS,
        version
      };
    }
  },
  {
    test(parser) {
      const notLikeAndroid = !parser.test(/like android/i);
      const butAndroid = parser.test(/android/i);
      return notLikeAndroid && butAndroid;
    },
    describe(ua) {
      const version = Utils.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, ua);
      const versionName = Utils.getAndroidVersionName(version);
      const os = {
        name: OS_MAP.Android,
        version
      };
      if (versionName) {
        os.versionName = versionName;
      }
      return os;
    }
  },
  {
    test: [/(web|hpw)[o0]s/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, ua);
      const os = {
        name: OS_MAP.WebOS
      };
      if (version && version.length) {
        os.version = version;
      }
      return os;
    }
  },
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, ua) || Utils.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, ua) || Utils.getFirstMatch(/\bbb(\d+)/i, ua);
      return {
        name: OS_MAP.BlackBerry,
        version
      };
    }
  },
  {
    test: [/bada/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.Bada,
        version
      };
    }
  },
  {
    test: [/tizen/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.Tizen,
        version
      };
    }
  },
  {
    test: [/linux/i],
    describe() {
      return {
        name: OS_MAP.Linux
      };
    }
  },
  {
    test: [/CrOS/],
    describe() {
      return {
        name: OS_MAP.ChromeOS
      };
    }
  },
  {
    test: [/PlayStation 4/],
    describe(ua) {
      const version = Utils.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.PlayStation4,
        version
      };
    }
  }
];
var platformParsersList = [
  {
    test: [/googlebot/i],
    describe() {
      return {
        type: "bot",
        vendor: "Google"
      };
    }
  },
  {
    test: [/huawei/i],
    describe(ua) {
      const model = Utils.getFirstMatch(/(can-l01)/i, ua) && "Nova";
      const platform = {
        type: PLATFORMS_MAP.mobile,
        vendor: "Huawei"
      };
      if (model) {
        platform.model = model;
      }
      return platform;
    }
  },
  {
    test: [/nexus\s*(?:7|8|9|10).*/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Nexus"
      };
    }
  },
  {
    test: [/ipad/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  {
    test: [/kftt build/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Amazon",
        model: "Kindle Fire HD 7"
      };
    }
  },
  {
    test: [/silk/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Amazon"
      };
    }
  },
  {
    test: [/tablet(?! pc)/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet
      };
    }
  },
  {
    test(parser) {
      const iDevice = parser.test(/ipod|iphone/i);
      const likeIDevice = parser.test(/like (ipod|iphone)/i);
      return iDevice && !likeIDevice;
    },
    describe(ua) {
      const model = Utils.getFirstMatch(/(ipod|iphone)/i, ua);
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "Apple",
        model
      };
    }
  },
  {
    test: [/nexus\s*[0-6].*/i, /galaxy nexus/i],
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "Nexus"
      };
    }
  },
  {
    test: [/[^-]mobi/i],
    describe() {
      return {
        type: PLATFORMS_MAP.mobile
      };
    }
  },
  {
    test(parser) {
      return parser.getBrowserName(true) === "blackberry";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "BlackBerry"
      };
    }
  },
  {
    test(parser) {
      return parser.getBrowserName(true) === "bada";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile
      };
    }
  },
  {
    test(parser) {
      return parser.getBrowserName() === "windows phone";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "Microsoft"
      };
    }
  },
  {
    test(parser) {
      const osMajorVersion = Number(String(parser.getOSVersion()).split(".")[0]);
      return parser.getOSName(true) === "android" && osMajorVersion >= 3;
    },
    describe() {
      return {
        type: PLATFORMS_MAP.tablet
      };
    }
  },
  {
    test(parser) {
      return parser.getOSName(true) === "android";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile
      };
    }
  },
  {
    test(parser) {
      return parser.getOSName(true) === "macos";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.desktop,
        vendor: "Apple"
      };
    }
  },
  {
    test(parser) {
      return parser.getOSName(true) === "windows";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.desktop
      };
    }
  },
  {
    test(parser) {
      return parser.getOSName(true) === "linux";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.desktop
      };
    }
  },
  {
    test(parser) {
      return parser.getOSName(true) === "playstation 4";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.tv
      };
    }
  },
  {
    test(parser) {
      return parser.getOSName(true) === "roku";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.tv
      };
    }
  }
];
var enginesParsersList = [
  {
    test(parser) {
      return parser.getBrowserName(true) === "microsoft edge";
    },
    describe(ua) {
      const isBlinkBased = /\sedg\//i.test(ua);
      if (isBlinkBased) {
        return {
          name: ENGINE_MAP.Blink
        };
      }
      const version = Utils.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, ua);
      return {
        name: ENGINE_MAP.EdgeHTML,
        version
      };
    }
  },
  {
    test: [/trident/i],
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.Trident
      };
      const version = Utils.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        engine.version = version;
      }
      return engine;
    }
  },
  {
    test(parser) {
      return parser.test(/presto/i);
    },
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.Presto
      };
      const version = Utils.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        engine.version = version;
      }
      return engine;
    }
  },
  {
    test(parser) {
      const isGecko = parser.test(/gecko/i);
      const likeGecko = parser.test(/like gecko/i);
      return isGecko && !likeGecko;
    },
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.Gecko
      };
      const version = Utils.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        engine.version = version;
      }
      return engine;
    }
  },
  {
    test: [/(apple)?webkit\/537\.36/i],
    describe() {
      return {
        name: ENGINE_MAP.Blink
      };
    }
  },
  {
    test: [/(apple)?webkit/i],
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.WebKit
      };
      const version = Utils.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        engine.version = version;
      }
      return engine;
    }
  }
];
class Parser {
  constructor(UA, skipParsing = false) {
    if (UA === void 0 || UA === null || UA === "") {
      throw new Error("UserAgent parameter can't be empty");
    }
    this._ua = UA;
    this.parsedResult = {};
    if (skipParsing !== true) {
      this.parse();
    }
  }
  getUA() {
    return this._ua;
  }
  test(regex) {
    return regex.test(this._ua);
  }
  parseBrowser() {
    this.parsedResult.browser = {};
    const browserDescriptor = Utils.find(browsersList, (_browser) => {
      if (typeof _browser.test === "function") {
        return _browser.test(this);
      }
      if (_browser.test instanceof Array) {
        return _browser.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (browserDescriptor) {
      this.parsedResult.browser = browserDescriptor.describe(this.getUA());
    }
    return this.parsedResult.browser;
  }
  getBrowser() {
    if (this.parsedResult.browser) {
      return this.parsedResult.browser;
    }
    return this.parseBrowser();
  }
  getBrowserName(toLowerCase) {
    if (toLowerCase) {
      return String(this.getBrowser().name).toLowerCase() || "";
    }
    return this.getBrowser().name || "";
  }
  getBrowserVersion() {
    return this.getBrowser().version;
  }
  getOS() {
    if (this.parsedResult.os) {
      return this.parsedResult.os;
    }
    return this.parseOS();
  }
  parseOS() {
    this.parsedResult.os = {};
    const os = Utils.find(osParsersList, (_os) => {
      if (typeof _os.test === "function") {
        return _os.test(this);
      }
      if (_os.test instanceof Array) {
        return _os.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (os) {
      this.parsedResult.os = os.describe(this.getUA());
    }
    return this.parsedResult.os;
  }
  getOSName(toLowerCase) {
    const { name } = this.getOS();
    if (toLowerCase) {
      return String(name).toLowerCase() || "";
    }
    return name || "";
  }
  getOSVersion() {
    return this.getOS().version;
  }
  getPlatform() {
    if (this.parsedResult.platform) {
      return this.parsedResult.platform;
    }
    return this.parsePlatform();
  }
  getPlatformType(toLowerCase = false) {
    const { type } = this.getPlatform();
    if (toLowerCase) {
      return String(type).toLowerCase() || "";
    }
    return type || "";
  }
  parsePlatform() {
    this.parsedResult.platform = {};
    const platform = Utils.find(platformParsersList, (_platform) => {
      if (typeof _platform.test === "function") {
        return _platform.test(this);
      }
      if (_platform.test instanceof Array) {
        return _platform.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (platform) {
      this.parsedResult.platform = platform.describe(this.getUA());
    }
    return this.parsedResult.platform;
  }
  getEngine() {
    if (this.parsedResult.engine) {
      return this.parsedResult.engine;
    }
    return this.parseEngine();
  }
  getEngineName(toLowerCase) {
    if (toLowerCase) {
      return String(this.getEngine().name).toLowerCase() || "";
    }
    return this.getEngine().name || "";
  }
  parseEngine() {
    this.parsedResult.engine = {};
    const engine = Utils.find(enginesParsersList, (_engine) => {
      if (typeof _engine.test === "function") {
        return _engine.test(this);
      }
      if (_engine.test instanceof Array) {
        return _engine.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (engine) {
      this.parsedResult.engine = engine.describe(this.getUA());
    }
    return this.parsedResult.engine;
  }
  parse() {
    this.parseBrowser();
    this.parseOS();
    this.parsePlatform();
    this.parseEngine();
    return this;
  }
  getResult() {
    return Utils.assign({}, this.parsedResult);
  }
  satisfies(checkTree) {
    const platformsAndOSes = {};
    let platformsAndOSCounter = 0;
    const browsers = {};
    let browsersCounter = 0;
    const allDefinitions = Object.keys(checkTree);
    allDefinitions.forEach((key) => {
      const currentDefinition = checkTree[key];
      if (typeof currentDefinition === "string") {
        browsers[key] = currentDefinition;
        browsersCounter += 1;
      } else if (typeof currentDefinition === "object") {
        platformsAndOSes[key] = currentDefinition;
        platformsAndOSCounter += 1;
      }
    });
    if (platformsAndOSCounter > 0) {
      const platformsAndOSNames = Object.keys(platformsAndOSes);
      const OSMatchingDefinition = Utils.find(platformsAndOSNames, (name) => this.isOS(name));
      if (OSMatchingDefinition) {
        const osResult = this.satisfies(platformsAndOSes[OSMatchingDefinition]);
        if (osResult !== void 0) {
          return osResult;
        }
      }
      const platformMatchingDefinition = Utils.find(
        platformsAndOSNames,
        (name) => this.isPlatform(name)
      );
      if (platformMatchingDefinition) {
        const platformResult = this.satisfies(platformsAndOSes[platformMatchingDefinition]);
        if (platformResult !== void 0) {
          return platformResult;
        }
      }
    }
    if (browsersCounter > 0) {
      const browserNames = Object.keys(browsers);
      const matchingDefinition = Utils.find(browserNames, (name) => this.isBrowser(name, true));
      if (matchingDefinition !== void 0) {
        return this.compareVersion(browsers[matchingDefinition]);
      }
    }
    return void 0;
  }
  isBrowser(browserName, includingAlias = false) {
    const defaultBrowserName = this.getBrowserName().toLowerCase();
    let browserNameLower = browserName.toLowerCase();
    const alias = Utils.getBrowserTypeByAlias(browserNameLower);
    if (includingAlias && alias) {
      browserNameLower = alias.toLowerCase();
    }
    return browserNameLower === defaultBrowserName;
  }
  compareVersion(version) {
    let expectedResults = [0];
    let comparableVersion = version;
    let isLoose = false;
    const currentBrowserVersion = this.getBrowserVersion();
    if (typeof currentBrowserVersion !== "string") {
      return void 0;
    }
    if (version[0] === ">" || version[0] === "<") {
      comparableVersion = version.substr(1);
      if (version[1] === "=") {
        isLoose = true;
        comparableVersion = version.substr(2);
      } else {
        expectedResults = [];
      }
      if (version[0] === ">") {
        expectedResults.push(1);
      } else {
        expectedResults.push(-1);
      }
    } else if (version[0] === "=") {
      comparableVersion = version.substr(1);
    } else if (version[0] === "~") {
      isLoose = true;
      comparableVersion = version.substr(1);
    }
    return expectedResults.indexOf(
      Utils.compareVersions(currentBrowserVersion, comparableVersion, isLoose)
    ) > -1;
  }
  isOS(osName) {
    return this.getOSName(true) === String(osName).toLowerCase();
  }
  isPlatform(platformType) {
    return this.getPlatformType(true) === String(platformType).toLowerCase();
  }
  isEngine(engineName) {
    return this.getEngineName(true) === String(engineName).toLowerCase();
  }
  is(anything, includingAlias = false) {
    return this.isBrowser(anything, includingAlias) || this.isOS(anything) || this.isPlatform(anything);
  }
  some(anythings = []) {
    return anythings.some((anything) => this.is(anything));
  }
}
/*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */
class Bowser {
  static getParser(UA, skipParsing = false) {
    if (typeof UA !== "string") {
      throw new Error("UserAgent should be a string");
    }
    return new Parser(UA, skipParsing);
  }
  static parse(UA) {
    return new Parser(UA).getResult();
  }
  static get BROWSER_MAP() {
    return BROWSER_MAP;
  }
  static get ENGINE_MAP() {
    return ENGINE_MAP;
  }
  static get OS_MAP() {
    return OS_MAP;
  }
  static get PLATFORMS_MAP() {
    return PLATFORMS_MAP;
  }
}
class BackgroundTransformer {
  constructor() {
    this.createCameraVideoElement = (rawVideoTrack) => {
      const cameraTrack = rawVideoTrack;
      const { height, width } = cameraTrack.getSettings();
      if (height === void 0 || width === void 0) {
        throw Error("Background removal can't commence as Height and Width of the video feed is undefined");
      }
      const cameraVideoElement = document.createElement("video");
      cameraVideoElement.width = width;
      cameraVideoElement.height = height;
      cameraVideoElement.srcObject = new MediaStream([cameraTrack]);
      return cameraVideoElement;
    };
  }
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
(function() {
  var x;
  function aa(a) {
    var b = 0;
    return function() {
      return b < a.length ? { done: false, value: a[b++] } : { done: true };
    };
  }
  var ba = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
    if (a == Array.prototype || a == Object.prototype)
      return a;
    a[b] = c.value;
    return a;
  };
  function ca(a) {
    a = ["object" == typeof globalThis && globalThis, a, "object" == typeof window && window, "object" == typeof self && self, "object" == typeof commonjsGlobal && commonjsGlobal];
    for (var b = 0; b < a.length; ++b) {
      var c = a[b];
      if (c && c.Math == Math)
        return c;
    }
    throw Error("Cannot find global object");
  }
  var y = ca(this);
  function z(a, b) {
    if (b)
      a: {
        var c = y;
        a = a.split(".");
        for (var d = 0; d < a.length - 1; d++) {
          var f = a[d];
          if (!(f in c))
            break a;
          c = c[f];
        }
        a = a[a.length - 1];
        d = c[a];
        b = b(d);
        b != d && null != b && ba(c, a, { configurable: true, writable: true, value: b });
      }
  }
  z("Symbol", function(a) {
    function b(g) {
      if (this instanceof b)
        throw new TypeError("Symbol is not a constructor");
      return new c(d + (g || "") + "_" + f++, g);
    }
    function c(g, e) {
      this.h = g;
      ba(this, "description", { configurable: true, writable: true, value: e });
    }
    if (a)
      return a;
    c.prototype.toString = function() {
      return this.h;
    };
    var d = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", f = 0;
    return b;
  });
  z("Symbol.iterator", function(a) {
    if (a)
      return a;
    a = Symbol("Symbol.iterator");
    for (var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++) {
      var d = y[b[c]];
      "function" === typeof d && "function" != typeof d.prototype[a] && ba(d.prototype, a, { configurable: true, writable: true, value: function() {
        return da(aa(this));
      } });
    }
    return a;
  });
  function da(a) {
    a = { next: a };
    a[Symbol.iterator] = function() {
      return this;
    };
    return a;
  }
  function A(a) {
    var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
    return b ? b.call(a) : { next: aa(a) };
  }
  function ea(a) {
    if (!(a instanceof Array)) {
      a = A(a);
      for (var b, c = []; !(b = a.next()).done; )
        c.push(b.value);
      a = c;
    }
    return a;
  }
  var fa = "function" == typeof Object.assign ? Object.assign : function(a, b) {
    for (var c = 1; c < arguments.length; c++) {
      var d = arguments[c];
      if (d)
        for (var f in d)
          Object.prototype.hasOwnProperty.call(d, f) && (a[f] = d[f]);
    }
    return a;
  };
  z("Object.assign", function(a) {
    return a || fa;
  });
  var ha = "function" == typeof Object.create ? Object.create : function(a) {
    function b() {
    }
    b.prototype = a;
    return new b();
  }, ia;
  if ("function" == typeof Object.setPrototypeOf)
    ia = Object.setPrototypeOf;
  else {
    var ja;
    a: {
      var ka = { a: true }, la = {};
      try {
        la.__proto__ = ka;
        ja = la.a;
        break a;
      } catch (a) {
      }
      ja = false;
    }
    ia = ja ? function(a, b) {
      a.__proto__ = b;
      if (a.__proto__ !== b)
        throw new TypeError(a + " is not extensible");
      return a;
    } : null;
  }
  var ma = ia;
  function D(a, b) {
    a.prototype = ha(b.prototype);
    a.prototype.constructor = a;
    if (ma)
      ma(a, b);
    else
      for (var c in b)
        if ("prototype" != c)
          if (Object.defineProperties) {
            var d = Object.getOwnPropertyDescriptor(b, c);
            d && Object.defineProperty(a, c, d);
          } else
            a[c] = b[c];
    a.za = b.prototype;
  }
  function na() {
    this.m = false;
    this.j = null;
    this.i = void 0;
    this.h = 1;
    this.v = this.s = 0;
    this.l = null;
  }
  function oa(a) {
    if (a.m)
      throw new TypeError("Generator is already running");
    a.m = true;
  }
  na.prototype.u = function(a) {
    this.i = a;
  };
  function pa(a, b) {
    a.l = { ma: b, na: true };
    a.h = a.s || a.v;
  }
  na.prototype.return = function(a) {
    this.l = { return: a };
    this.h = this.v;
  };
  function E(a, b, c) {
    a.h = c;
    return { value: b };
  }
  function qa(a) {
    this.h = new na();
    this.i = a;
  }
  function ra(a, b) {
    oa(a.h);
    var c = a.h.j;
    if (c)
      return sa(a, "return" in c ? c["return"] : function(d) {
        return { value: d, done: true };
      }, b, a.h.return);
    a.h.return(b);
    return ta(a);
  }
  function sa(a, b, c, d) {
    try {
      var f = b.call(a.h.j, c);
      if (!(f instanceof Object))
        throw new TypeError("Iterator result " + f + " is not an object");
      if (!f.done)
        return a.h.m = false, f;
      var g = f.value;
    } catch (e) {
      return a.h.j = null, pa(a.h, e), ta(a);
    }
    a.h.j = null;
    d.call(a.h, g);
    return ta(a);
  }
  function ta(a) {
    for (; a.h.h; )
      try {
        var b = a.i(a.h);
        if (b)
          return a.h.m = false, { value: b.value, done: false };
      } catch (c) {
        a.h.i = void 0, pa(a.h, c);
      }
    a.h.m = false;
    if (a.h.l) {
      b = a.h.l;
      a.h.l = null;
      if (b.na)
        throw b.ma;
      return { value: b.return, done: true };
    }
    return { value: void 0, done: true };
  }
  function ua(a) {
    this.next = function(b) {
      oa(a.h);
      a.h.j ? b = sa(a, a.h.j.next, b, a.h.u) : (a.h.u(b), b = ta(a));
      return b;
    };
    this.throw = function(b) {
      oa(a.h);
      a.h.j ? b = sa(a, a.h.j["throw"], b, a.h.u) : (pa(a.h, b), b = ta(a));
      return b;
    };
    this.return = function(b) {
      return ra(a, b);
    };
    this[Symbol.iterator] = function() {
      return this;
    };
  }
  function va(a) {
    function b(d) {
      return a.next(d);
    }
    function c(d) {
      return a.throw(d);
    }
    return new Promise(function(d, f) {
      function g(e) {
        e.done ? d(e.value) : Promise.resolve(e.value).then(b, c).then(g, f);
      }
      g(a.next());
    });
  }
  function F(a) {
    return va(new ua(new qa(a)));
  }
  z("Promise", function(a) {
    function b(e) {
      this.i = 0;
      this.j = void 0;
      this.h = [];
      this.u = false;
      var h = this.l();
      try {
        e(h.resolve, h.reject);
      } catch (k) {
        h.reject(k);
      }
    }
    function c() {
      this.h = null;
    }
    function d(e) {
      return e instanceof b ? e : new b(function(h) {
        h(e);
      });
    }
    if (a)
      return a;
    c.prototype.i = function(e) {
      if (null == this.h) {
        this.h = [];
        var h = this;
        this.j(function() {
          h.m();
        });
      }
      this.h.push(e);
    };
    var f = y.setTimeout;
    c.prototype.j = function(e) {
      f(e, 0);
    };
    c.prototype.m = function() {
      for (; this.h && this.h.length; ) {
        var e = this.h;
        this.h = [];
        for (var h = 0; h < e.length; ++h) {
          var k = e[h];
          e[h] = null;
          try {
            k();
          } catch (l) {
            this.l(l);
          }
        }
      }
      this.h = null;
    };
    c.prototype.l = function(e) {
      this.j(function() {
        throw e;
      });
    };
    b.prototype.l = function() {
      function e(l) {
        return function(m) {
          k || (k = true, l.call(h, m));
        };
      }
      var h = this, k = false;
      return { resolve: e(this.I), reject: e(this.m) };
    };
    b.prototype.I = function(e) {
      if (e === this)
        this.m(new TypeError("A Promise cannot resolve to itself"));
      else if (e instanceof b)
        this.L(e);
      else {
        a:
          switch (typeof e) {
            case "object":
              var h = null != e;
              break a;
            case "function":
              h = true;
              break a;
            default:
              h = false;
          }
        h ? this.F(e) : this.s(e);
      }
    };
    b.prototype.F = function(e) {
      var h = void 0;
      try {
        h = e.then;
      } catch (k) {
        this.m(k);
        return;
      }
      "function" == typeof h ? this.M(h, e) : this.s(e);
    };
    b.prototype.m = function(e) {
      this.v(2, e);
    };
    b.prototype.s = function(e) {
      this.v(1, e);
    };
    b.prototype.v = function(e, h) {
      if (0 != this.i)
        throw Error("Cannot settle(" + e + ", " + h + "): Promise already settled in state" + this.i);
      this.i = e;
      this.j = h;
      2 === this.i && this.K();
      this.H();
    };
    b.prototype.K = function() {
      var e = this;
      f(function() {
        if (e.D()) {
          var h = y.console;
          "undefined" !== typeof h && h.error(e.j);
        }
      }, 1);
    };
    b.prototype.D = function() {
      if (this.u)
        return false;
      var e = y.CustomEvent, h = y.Event, k = y.dispatchEvent;
      if ("undefined" === typeof k)
        return true;
      "function" === typeof e ? e = new e("unhandledrejection", { cancelable: true }) : "function" === typeof h ? e = new h("unhandledrejection", { cancelable: true }) : (e = y.document.createEvent("CustomEvent"), e.initCustomEvent("unhandledrejection", false, true, e));
      e.promise = this;
      e.reason = this.j;
      return k(e);
    };
    b.prototype.H = function() {
      if (null != this.h) {
        for (var e = 0; e < this.h.length; ++e)
          g.i(this.h[e]);
        this.h = null;
      }
    };
    var g = new c();
    b.prototype.L = function(e) {
      var h = this.l();
      e.T(h.resolve, h.reject);
    };
    b.prototype.M = function(e, h) {
      var k = this.l();
      try {
        e.call(h, k.resolve, k.reject);
      } catch (l) {
        k.reject(l);
      }
    };
    b.prototype.then = function(e, h) {
      function k(p, n) {
        return "function" == typeof p ? function(q) {
          try {
            l(p(q));
          } catch (t) {
            m(t);
          }
        } : n;
      }
      var l, m, r = new b(function(p, n) {
        l = p;
        m = n;
      });
      this.T(k(e, l), k(h, m));
      return r;
    };
    b.prototype.catch = function(e) {
      return this.then(void 0, e);
    };
    b.prototype.T = function(e, h) {
      function k() {
        switch (l.i) {
          case 1:
            e(l.j);
            break;
          case 2:
            h(l.j);
            break;
          default:
            throw Error("Unexpected state: " + l.i);
        }
      }
      var l = this;
      null == this.h ? g.i(k) : this.h.push(k);
      this.u = true;
    };
    b.resolve = d;
    b.reject = function(e) {
      return new b(function(h, k) {
        k(e);
      });
    };
    b.race = function(e) {
      return new b(function(h, k) {
        for (var l = A(e), m = l.next(); !m.done; m = l.next())
          d(m.value).T(h, k);
      });
    };
    b.all = function(e) {
      var h = A(e), k = h.next();
      return k.done ? d([]) : new b(function(l, m) {
        function r(q) {
          return function(t) {
            p[q] = t;
            n--;
            0 == n && l(p);
          };
        }
        var p = [], n = 0;
        do
          p.push(void 0), n++, d(k.value).T(r(p.length - 1), m), k = h.next();
        while (!k.done);
      });
    };
    return b;
  });
  z("Number.isNaN", function(a) {
    return a ? a : function(b) {
      return "number" === typeof b && isNaN(b);
    };
  });
  function wa(a, b) {
    a instanceof String && (a += "");
    var c = 0, d = false, f = { next: function() {
      if (!d && c < a.length) {
        var g = c++;
        return { value: b(g, a[g]), done: false };
      }
      d = true;
      return { done: true, value: void 0 };
    } };
    f[Symbol.iterator] = function() {
      return f;
    };
    return f;
  }
  z("Array.prototype.keys", function(a) {
    return a ? a : function() {
      return wa(this, function(b) {
        return b;
      });
    };
  });
  z("Array.prototype.fill", function(a) {
    return a ? a : function(b, c, d) {
      var f = this.length || 0;
      0 > c && (c = Math.max(0, f + c));
      if (null == d || d > f)
        d = f;
      d = Number(d);
      0 > d && (d = Math.max(0, f + d));
      for (c = Number(c || 0); c < d; c++)
        this[c] = b;
      return this;
    };
  });
  function G(a) {
    return a ? a : Array.prototype.fill;
  }
  z("Int8Array.prototype.fill", G);
  z("Uint8Array.prototype.fill", G);
  z("Uint8ClampedArray.prototype.fill", G);
  z("Int16Array.prototype.fill", G);
  z("Uint16Array.prototype.fill", G);
  z("Int32Array.prototype.fill", G);
  z("Uint32Array.prototype.fill", G);
  z("Float32Array.prototype.fill", G);
  z("Float64Array.prototype.fill", G);
  z("Object.is", function(a) {
    return a ? a : function(b, c) {
      return b === c ? 0 !== b || 1 / b === 1 / c : b !== b && c !== c;
    };
  });
  z("Array.prototype.includes", function(a) {
    return a ? a : function(b, c) {
      var d = this;
      d instanceof String && (d = String(d));
      var f = d.length;
      c = c || 0;
      for (0 > c && (c = Math.max(c + f, 0)); c < f; c++) {
        var g = d[c];
        if (g === b || Object.is(g, b))
          return true;
      }
      return false;
    };
  });
  z("String.prototype.includes", function(a) {
    return a ? a : function(b, c) {
      if (null == this)
        throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
      if (b instanceof RegExp)
        throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
      return -1 !== this.indexOf(b, c || 0);
    };
  });
  var ya = this || self;
  function za(a, b) {
    a = a.split(".");
    var c = ya;
    a[0] in c || "undefined" == typeof c.execScript || c.execScript("var " + a[0]);
    for (var d; a.length && (d = a.shift()); )
      a.length || void 0 === b ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
  }
  var Aa = Array.prototype.map ? function(a, b) {
    return Array.prototype.map.call(a, b, void 0);
  } : function(a, b) {
    for (var c = a.length, d = Array(c), f = "string" === typeof a ? a.split("") : a, g = 0; g < c; g++)
      g in f && (d[g] = b.call(void 0, f[g], g, a));
    return d;
  };
  var Ba = {}, Ca = null;
  function Da(a) {
    var b;
    void 0 === b && (b = 0);
    Ea();
    b = Ba[b];
    for (var c = Array(Math.floor(a.length / 3)), d = b[64] || "", f = 0, g = 0; f < a.length - 2; f += 3) {
      var e = a[f], h = a[f + 1], k = a[f + 2], l = b[e >> 2];
      e = b[(e & 3) << 4 | h >> 4];
      h = b[(h & 15) << 2 | k >> 6];
      k = b[k & 63];
      c[g++] = l + e + h + k;
    }
    l = 0;
    k = d;
    switch (a.length - f) {
      case 2:
        l = a[f + 1], k = b[(l & 15) << 2] || d;
      case 1:
        a = a[f], c[g] = b[a >> 2] + b[(a & 3) << 4 | l >> 4] + k + d;
    }
    return c.join("");
  }
  function Fa(a) {
    var b = a.length, c = 3 * b / 4;
    c % 3 ? c = Math.floor(c) : -1 != "=.".indexOf(a[b - 1]) && (c = -1 != "=.".indexOf(a[b - 2]) ? c - 2 : c - 1);
    var d = new Uint8Array(c), f = 0;
    Ga(a, function(g) {
      d[f++] = g;
    });
    return f !== c ? d.subarray(0, f) : d;
  }
  function Ga(a, b) {
    function c(k) {
      for (; d < a.length; ) {
        var l = a.charAt(d++), m = Ca[l];
        if (null != m)
          return m;
        if (!/^[\s\xa0]*$/.test(l))
          throw Error("Unknown base64 encoding at char: " + l);
      }
      return k;
    }
    Ea();
    for (var d = 0; ; ) {
      var f = c(-1), g = c(0), e = c(64), h = c(64);
      if (64 === h && -1 === f)
        break;
      b(f << 2 | g >> 4);
      64 != e && (b(g << 4 & 240 | e >> 2), 64 != h && b(e << 6 & 192 | h));
    }
  }
  function Ea() {
    if (!Ca) {
      Ca = {};
      for (var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = ["+/=", "+/", "-_=", "-_.", "-_"], c = 0; 5 > c; c++) {
        var d = a.concat(b[c].split(""));
        Ba[c] = d;
        for (var f = 0; f < d.length; f++) {
          var g = d[f];
          void 0 === Ca[g] && (Ca[g] = f);
        }
      }
    }
  }
  var Ha = "undefined" !== typeof Uint8Array, Ia;
  function Ja() {
    return Ia || (Ia = new Uint8Array(0));
  }
  var Ka = {};
  var La = "function" === typeof Uint8Array.prototype.slice, H = 0, K = 0;
  function Ma(a) {
    var b = 0 > a;
    a = Math.abs(a);
    var c = a >>> 0;
    a = Math.floor((a - c) / 4294967296);
    b && (c = A(Na(c, a)), b = c.next().value, a = c.next().value, c = b);
    H = c >>> 0;
    K = a >>> 0;
  }
  var Oa = "function" === typeof BigInt;
  function Na(a, b) {
    b = ~b;
    a ? a = ~a + 1 : b += 1;
    return [a, b];
  }
  function Pa(a, b) {
    this.i = a >>> 0;
    this.h = b >>> 0;
  }
  function Qa(a) {
    if (!a)
      return Ra || (Ra = new Pa(0, 0));
    if (!/^-?\d+$/.test(a))
      return null;
    if (16 > a.length)
      Ma(Number(a));
    else if (Oa)
      a = BigInt(a), H = Number(a & BigInt(4294967295)) >>> 0, K = Number(a >> BigInt(32) & BigInt(4294967295));
    else {
      var b = +("-" === a[0]);
      K = H = 0;
      for (var c = a.length, d = b, f = (c - b) % 6 + b; f <= c; d = f, f += 6)
        d = Number(a.slice(d, f)), K *= 1e6, H = 1e6 * H + d, 4294967296 <= H && (K += H / 4294967296 | 0, H %= 4294967296);
      b && (b = A(Na(H, K)), a = b.next().value, b = b.next().value, H = a, K = b);
    }
    return new Pa(H, K);
  }
  var Ra;
  function Sa(a, b) {
    return Error("Invalid wire type: " + a + " (at position " + b + ")");
  }
  function Ta() {
    return Error("Failed to read varint, encoding is invalid.");
  }
  function Ua(a, b) {
    return Error("Tried to read past the end of the data " + b + " > " + a);
  }
  function L() {
    throw Error("Invalid UTF8");
  }
  function Va(a, b) {
    b = String.fromCharCode.apply(null, b);
    return null == a ? b : a + b;
  }
  var Wa = void 0, Xa, Ya = "undefined" !== typeof TextDecoder, Za, $a = "undefined" !== typeof TextEncoder;
  var ab;
  function bb(a) {
    if (a !== Ka)
      throw Error("illegal external caller");
  }
  function cb(a, b) {
    bb(b);
    this.V = a;
    if (null != a && 0 === a.length)
      throw Error("ByteString should be constructed with non-empty values");
  }
  function db() {
    return ab || (ab = new cb(null, Ka));
  }
  function eb(a) {
    bb(Ka);
    var b = a.V;
    b = null == b || Ha && null != b && b instanceof Uint8Array ? b : "string" === typeof b ? Fa(b) : null;
    return null == b ? b : a.V = b;
  }
  function fb(a) {
    if ("string" === typeof a)
      return { buffer: Fa(a), C: false };
    if (Array.isArray(a))
      return { buffer: new Uint8Array(a), C: false };
    if (a.constructor === Uint8Array)
      return { buffer: a, C: false };
    if (a.constructor === ArrayBuffer)
      return { buffer: new Uint8Array(a), C: false };
    if (a.constructor === cb)
      return { buffer: eb(a) || Ja(), C: true };
    if (a instanceof Uint8Array)
      return { buffer: new Uint8Array(a.buffer, a.byteOffset, a.byteLength), C: false };
    throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, a ByteString or an Array of numbers");
  }
  function gb(a) {
    this.i = null;
    this.m = false;
    this.h = this.j = this.l = 0;
    hb(this, a);
  }
  function hb(a, b) {
    var c = {};
    a.S = void 0 === c.S ? false : c.S;
    b && (b = fb(b), a.i = b.buffer, a.m = b.C, a.l = 0, a.j = a.i.length, a.h = a.l);
  }
  gb.prototype.reset = function() {
    this.h = this.l;
  };
  function M(a, b) {
    a.h = b;
    if (b > a.j)
      throw Ua(a.j, b);
  }
  function ib(a) {
    var b = a.i, c = a.h, d = b[c++], f = d & 127;
    if (d & 128 && (d = b[c++], f |= (d & 127) << 7, d & 128 && (d = b[c++], f |= (d & 127) << 14, d & 128 && (d = b[c++], f |= (d & 127) << 21, d & 128 && (d = b[c++], f |= d << 28, d & 128 && b[c++] & 128 && b[c++] & 128 && b[c++] & 128 && b[c++] & 128 && b[c++] & 128)))))
      throw Ta();
    M(a, c);
    return f;
  }
  function jb(a, b) {
    if (0 > b)
      throw Error("Tried to read a negative byte length: " + b);
    var c = a.h, d = c + b;
    if (d > a.j)
      throw Ua(b, a.j - c);
    a.h = d;
    return c;
  }
  var kb = [];
  function lb() {
    this.h = [];
  }
  lb.prototype.length = function() {
    return this.h.length;
  };
  lb.prototype.end = function() {
    var a = this.h;
    this.h = [];
    return a;
  };
  function mb(a, b, c) {
    for (; 0 < c || 127 < b; )
      a.h.push(b & 127 | 128), b = (b >>> 7 | c << 25) >>> 0, c >>>= 7;
    a.h.push(b);
  }
  function N(a, b) {
    for (; 127 < b; )
      a.h.push(b & 127 | 128), b >>>= 7;
    a.h.push(b);
  }
  function nb(a) {
    if (kb.length) {
      var b = kb.pop();
      hb(b, a);
      a = b;
    } else
      a = new gb(a);
    this.h = a;
    this.j = this.h.h;
    this.i = this.l = -1;
    this.setOptions(void 0);
  }
  nb.prototype.setOptions = function(a) {
    a = void 0 === a ? {} : a;
    this.ca = void 0 === a.ca ? false : a.ca;
  };
  nb.prototype.reset = function() {
    this.h.reset();
    this.j = this.h.h;
    this.i = this.l = -1;
  };
  function ob(a) {
    var b = a.h;
    if (b.h == b.j)
      return false;
    a.j = a.h.h;
    var c = ib(a.h) >>> 0;
    b = c >>> 3;
    c &= 7;
    if (!(0 <= c && 5 >= c))
      throw Sa(c, a.j);
    if (1 > b)
      throw Error("Invalid field number: " + b + " (at position " + a.j + ")");
    a.l = b;
    a.i = c;
    return true;
  }
  function pb(a) {
    switch (a.i) {
      case 0:
        if (0 != a.i)
          pb(a);
        else
          a: {
            a = a.h;
            for (var b = a.h, c = b + 10, d = a.i; b < c; )
              if (0 === (d[b++] & 128)) {
                M(a, b);
                break a;
              }
            throw Ta();
          }
        break;
      case 1:
        a = a.h;
        M(a, a.h + 8);
        break;
      case 2:
        2 != a.i ? pb(a) : (b = ib(a.h) >>> 0, a = a.h, M(a, a.h + b));
        break;
      case 5:
        a = a.h;
        M(a, a.h + 4);
        break;
      case 3:
        b = a.l;
        do {
          if (!ob(a))
            throw Error("Unmatched start-group tag: stream EOF");
          if (4 == a.i) {
            if (a.l != b)
              throw Error("Unmatched end-group tag");
            break;
          }
          pb(a);
        } while (1);
        break;
      default:
        throw Sa(a.i, a.j);
    }
  }
  var qb = [];
  function rb() {
    this.j = [];
    this.i = 0;
    this.h = new lb();
  }
  function O(a, b) {
    0 !== b.length && (a.j.push(b), a.i += b.length);
  }
  function sb(a, b) {
    if (b = b.R) {
      O(a, a.h.end());
      for (var c = 0; c < b.length; c++)
        O(a, eb(b[c]) || Ja());
    }
  }
  var P = "function" === typeof Symbol && "symbol" === typeof Symbol() ? Symbol() : void 0;
  function Q(a, b) {
    if (P)
      return a[P] |= b;
    if (void 0 !== a.A)
      return a.A |= b;
    Object.defineProperties(a, { A: { value: b, configurable: true, writable: true, enumerable: false } });
    return b;
  }
  function tb(a, b) {
    P ? a[P] && (a[P] &= ~b) : void 0 !== a.A && (a.A &= ~b);
  }
  function R(a) {
    var b;
    P ? b = a[P] : b = a.A;
    return null == b ? 0 : b;
  }
  function S(a, b) {
    P ? a[P] = b : void 0 !== a.A ? a.A = b : Object.defineProperties(a, { A: { value: b, configurable: true, writable: true, enumerable: false } });
  }
  function ub(a) {
    Q(a, 1);
    return a;
  }
  function vb(a, b) {
    S(b, (a | 0) & -51);
  }
  function wb(a, b) {
    S(b, (a | 18) & -41);
  }
  var xb = {};
  function yb(a) {
    return null !== a && "object" === typeof a && !Array.isArray(a) && a.constructor === Object;
  }
  var zb, Ab = [];
  S(Ab, 23);
  zb = Object.freeze(Ab);
  function Bb(a) {
    if (R(a.o) & 2)
      throw Error("Cannot mutate an immutable Message");
  }
  function Cb(a) {
    var b = a.length;
    (b = b ? a[b - 1] : void 0) && yb(b) ? b.g = 1 : (b = {}, a.push((b.g = 1, b)));
  }
  var Db;
  function Eb(a) {
    switch (typeof a) {
      case "number":
        return isFinite(a) ? a : String(a);
      case "object":
        if (a)
          if (Array.isArray(a)) {
            if (0 !== (R(a) & 128))
              return a = Array.prototype.slice.call(a), Cb(a), a;
          } else {
            if (Ha && null != a && a instanceof Uint8Array)
              return Da(a);
            if (a instanceof cb) {
              var b = a.V;
              return null == b ? "" : "string" === typeof b ? b : a.V = Da(b);
            }
          }
    }
    return a;
  }
  function Fb(a, b, c, d) {
    if (null != a) {
      if (Array.isArray(a))
        a = Gb(a, b, c, void 0 !== d);
      else if (yb(a)) {
        var f = {}, g;
        for (g in a)
          f[g] = Fb(a[g], b, c, d);
        a = f;
      } else
        a = b(a, d);
      return a;
    }
  }
  function Gb(a, b, c, d) {
    var f = R(a);
    d = d ? !!(f & 16) : void 0;
    a = Array.prototype.slice.call(a);
    for (var g = 0; g < a.length; g++)
      a[g] = Fb(a[g], b, c, d);
    c(f, a);
    return a;
  }
  function Hb(a) {
    return a.ja === xb ? a.toJSON() : Eb(a);
  }
  function Ib(a, b) {
    a & 128 && Cb(b);
  }
  function Jb(a) {
    var b = a.i + a.G;
    return a.B || (a.B = a.o[b] = {});
  }
  function U(a, b) {
    return -1 === b ? null : b >= a.i ? a.B ? a.B[b] : void 0 : a.o[b + a.G];
  }
  function V(a, b, c, d) {
    Bb(a);
    Kb(a, b, c, d);
  }
  function Kb(a, b, c, d) {
    a.j && (a.j = void 0);
    b >= a.i || d ? Jb(a)[b] = c : (a.o[b + a.G] = c, (a = a.B) && b in a && delete a[b]);
  }
  function Lb(a, b, c, d) {
    var f = U(a, b);
    Array.isArray(f) || (f = zb);
    var g = R(f);
    g & 1 || ub(f);
    if (d)
      g & 2 || Q(f, 2), c & 1 || Object.freeze(f);
    else {
      d = !(c & 2);
      var e = g & 2;
      c & 1 || !e ? d && g & 16 && !e && tb(f, 16) : (f = ub(Array.prototype.slice.call(f)), Kb(a, b, f));
    }
    return f;
  }
  function Mb(a, b) {
    var c = U(a, b);
    if (null == c)
      return c;
    if ("number" === typeof c || "NaN" === c || "Infinity" === c || "-Infinity" === c) {
      var d = Number(c);
      d !== c && Kb(a, b, d);
      return d;
    }
  }
  function Nb(a, b, c, d, f) {
    a.h || (a.h = {});
    var g = a.h[c], e = Lb(a, c, 3, f);
    if (!g) {
      var h = e;
      g = [];
      var k = !!(R(a.o) & 16);
      e = !!(R(h) & 2);
      var l = h;
      !f && e && (h = Array.prototype.slice.call(h));
      for (var m = e, r = 0; r < h.length; r++) {
        var p = h[r];
        var n = b, q = false;
        q = void 0 === q ? false : q;
        p = Array.isArray(p) ? new n(p) : q ? new n() : void 0;
        if (void 0 !== p) {
          n = p.o;
          var t = q = R(n);
          e && (t |= 2);
          k && (t |= 16);
          t != q && S(n, t);
          n = t;
          m = m || !!(2 & n);
          g.push(p);
        }
      }
      a.h[c] = g;
      k = R(h);
      b = k | 33;
      b = m ? b & -9 : b | 8;
      k != b && (m = h, Object.isFrozen(m) && (m = Array.prototype.slice.call(m)), S(m, b), h = m);
      l !== h && Kb(
        a,
        c,
        h
      );
      (f || d && e) && Q(g, 2);
      d && Object.freeze(g);
      return g;
    }
    e = g;
    f || (Object.isFrozen(e) ? d || (g = Array.prototype.slice.call(g), a.h[c] = g) : d && Object.freeze(e));
    return g;
  }
  function Ob(a, b, c) {
    var d = !!(R(a.o) & 2);
    b = Nb(a, b, c, d, d);
    a = Lb(a, c, 3, d);
    if (!(d || R(a) & 8)) {
      for (d = 0; d < b.length; d++) {
        c = b[d];
        if (R(c.o) & 2) {
          var f = Pb(c, false);
          f.j = c;
        } else
          f = c;
        c !== f && (b[d] = f, a[d] = f.o);
      }
      Q(a, 8);
    }
    return b;
  }
  function W(a, b, c) {
    if (null != c && "number" !== typeof c)
      throw Error("Value of float field must be a number|null|undefined, found " + typeof c + ": " + c);
    V(a, b, c);
  }
  function Qb(a, b, c, d, f) {
    Bb(a);
    var g = Nb(a, c, b, false, false);
    c = null != d ? d : new c();
    a = Lb(a, b, 2, false);
    void 0 != f ? (g.splice(f, 0, c), a.splice(f, 0, c.o)) : (g.push(c), a.push(c.o));
    c.C() && tb(a, 8);
    return c;
  }
  function Rb(a, b) {
    return null == a ? b : a;
  }
  function X(a, b, c) {
    c = void 0 === c ? 0 : c;
    return Rb(Mb(a, b), c);
  }
  function Sb(a, b, c) {
    c = void 0 === c ? wb : c;
    if (null != a) {
      if (Ha && a instanceof Uint8Array)
        return a.length ? new cb(new Uint8Array(a), Ka) : db();
      if (Array.isArray(a)) {
        var d = R(a);
        if (d & 2)
          return a;
        if (b && !(d & 32) && (d & 16 || 0 === d))
          return S(a, d | 2), a;
        a = Gb(a, Sb, c, true);
        b = R(a);
        b & 4 && b & 2 && Object.freeze(a);
        return a;
      }
      return a.ja === xb ? Tb(a) : a;
    }
  }
  function Ub(a, b, c, d, f, g, e) {
    if (a = a.h && a.h[c]) {
      d = R(a);
      d & 2 ? d = a : (g = Aa(a, Tb), wb(d, g), Object.freeze(g), d = g);
      Bb(b);
      e = null == d ? zb : ub([]);
      if (null != d) {
        g = false;
        for (a = 0; a < d.length; a++) {
          var h = d[a];
          g = g || !!(R(h.o) & 2);
          e[a] = h.o;
        }
        g = (g ? 0 : 8) | 1;
        a = R(e);
        (a & g) !== g && (Object.isFrozen(e) && (e = Array.prototype.slice.call(e)), S(e, a | g));
        b.h || (b.h = {});
        b.h[c] = d;
      } else
        b.h && (b.h[c] = void 0);
      Kb(b, c, e, f);
    } else
      V(b, c, Sb(d, g, e), f);
  }
  function Tb(a) {
    if (R(a.o) & 2)
      return a;
    a = Pb(a, true);
    Q(a.o, 2);
    return a;
  }
  function Pb(a, b) {
    var c = a.o, d = [];
    Q(d, 16);
    var f = a.constructor.h;
    f && d.push(f);
    f = a.B;
    if (f) {
      d.length = c.length;
      d.fill(void 0, d.length, c.length);
      var g = {};
      d[d.length - 1] = g;
    }
    0 !== (R(c) & 128) && Cb(d);
    b = b || a.C() ? wb : vb;
    var e = a.constructor;
    Db = d;
    d = new e(d);
    Db = void 0;
    a.R && (d.R = a.R.slice());
    e = !!(R(c) & 16);
    for (var h = f ? c.length - 1 : c.length, k = 0; k < h; k++)
      Ub(a, d, k - a.G, c[k], false, e, b);
    if (f)
      for (var l in f)
        c = f[l], h = +l, Number.isNaN(h) ? g[h] = c : Ub(a, d, h, c, true, e, b);
    return d;
  }
  function Y(a, b, c) {
    null == a && (a = Db);
    Db = void 0;
    var d = this.constructor.i || 0, f = 0 < d, g = this.constructor.h, e = false;
    if (null == a) {
      a = g ? [g] : [];
      var h = true;
      S(a, 48);
    } else {
      if (!Array.isArray(a))
        throw Error();
      if (g && g !== a[0])
        throw Error();
      var k = Q(a, 0), l = k;
      if (h = 0 !== (16 & l))
        (e = 0 !== (32 & l)) || (l |= 32);
      if (f)
        if (128 & l)
          d = 0;
        else {
          if (0 < a.length) {
            var m = a[a.length - 1];
            if (yb(m) && "g" in m) {
              d = 0;
              l |= 128;
              delete m.g;
              var r = true, p;
              for (p in m) {
                r = false;
                break;
              }
              r && a.pop();
            }
          }
        }
      else if (128 & l)
        throw Error();
      k !== l && S(a, l);
    }
    this.G = (g ? 0 : -1) - d;
    this.h = void 0;
    this.o = a;
    a: {
      g = this.o.length;
      d = g - 1;
      if (g && (g = this.o[d], yb(g))) {
        this.B = g;
        this.i = d - this.G;
        break a;
      }
      void 0 !== b && -1 < b ? (this.i = Math.max(b, d + 1 - this.G), this.B = void 0) : this.i = Number.MAX_VALUE;
    }
    if (!f && this.B && "g" in this.B)
      throw Error('Unexpected "g" flag in sparse object of message that is not a group type.');
    if (c) {
      b = h && !e && true;
      f = this.i;
      var n;
      for (h = 0; h < c.length; h++)
        e = c[h], e < f ? (e += this.G, (d = a[e]) ? Vb(d, b) : a[e] = zb) : (n || (n = Jb(this)), (d = n[e]) ? Vb(d, b) : n[e] = zb);
    }
  }
  Y.prototype.toJSON = function() {
    return Gb(this.o, Hb, Ib);
  };
  Y.prototype.C = function() {
    return !!(R(this.o) & 2);
  };
  function Vb(a, b) {
    if (Array.isArray(a)) {
      var c = R(a), d = 1;
      !b || c & 2 || (d |= 16);
      (c & d) !== d && S(a, c | d);
    }
  }
  Y.prototype.ja = xb;
  Y.prototype.toString = function() {
    return this.o.toString();
  };
  function Wb(a, b, c) {
    if (c) {
      var d = {}, f;
      for (f in c) {
        var g = c[f], e = g.ra;
        e || (d.J = g.xa || g.oa.W, g.ia ? (d.aa = Xb(g.ia), e = function(h) {
          return function(k, l, m) {
            return h.J(k, l, m, h.aa);
          };
        }(d)) : g.ka ? (d.Z = Yb(g.da.P, g.ka), e = function(h) {
          return function(k, l, m) {
            return h.J(k, l, m, h.Z);
          };
        }(d)) : e = d.J, g.ra = e);
        e(b, a, g.da);
        d = { J: d.J, aa: d.aa, Z: d.Z };
      }
    }
    sb(b, a);
  }
  var Zb = Symbol();
  function $b(a, b, c) {
    return a[Zb] || (a[Zb] = function(d, f) {
      return b(d, f, c);
    });
  }
  function ac(a) {
    var b = a[Zb];
    if (!b) {
      var c = bc(a);
      b = function(d, f) {
        return cc(d, f, c);
      };
      a[Zb] = b;
    }
    return b;
  }
  function dc(a) {
    var b = a.ia;
    if (b)
      return ac(b);
    if (b = a.wa)
      return $b(a.da.P, b, a.ka);
  }
  function ec(a) {
    var b = dc(a), c = a.da, d = a.oa.U;
    return b ? function(f, g) {
      return d(f, g, c, b);
    } : function(f, g) {
      return d(f, g, c);
    };
  }
  function fc(a, b) {
    var c = a[b];
    "function" == typeof c && 0 === c.length && (c = c(), a[b] = c);
    return Array.isArray(c) && (gc in c || hc in c || 0 < c.length && "function" == typeof c[0]) ? c : void 0;
  }
  function ic(a, b, c, d, f, g) {
    b.P = a[0];
    var e = 1;
    if (a.length > e && "number" !== typeof a[e]) {
      var h = a[e++];
      c(b, h);
    }
    for (; e < a.length; ) {
      c = a[e++];
      for (var k = e + 1; k < a.length && "number" !== typeof a[k]; )
        k++;
      h = a[e++];
      k -= e;
      switch (k) {
        case 0:
          d(b, c, h);
          break;
        case 1:
          (k = fc(a, e)) ? (e++, f(b, c, h, k)) : d(b, c, h, a[e++]);
          break;
        case 2:
          k = e++;
          k = fc(a, k);
          f(b, c, h, k, a[e++]);
          break;
        case 3:
          g(b, c, h, a[e++], a[e++], a[e++]);
          break;
        case 4:
          g(b, c, h, a[e++], a[e++], a[e++], a[e++]);
          break;
        default:
          throw Error("unexpected number of binary field arguments: " + k);
      }
    }
    return b;
  }
  var jc = Symbol();
  function Xb(a) {
    var b = a[jc];
    if (!b) {
      var c = kc(a);
      b = function(d, f) {
        return lc(d, f, c);
      };
      a[jc] = b;
    }
    return b;
  }
  function Yb(a, b) {
    var c = a[jc];
    c || (c = function(d, f) {
      return Wb(d, f, b);
    }, a[jc] = c);
    return c;
  }
  var hc = Symbol();
  function mc(a, b) {
    a.push(b);
  }
  function nc(a, b, c) {
    a.push(b, c.W);
  }
  function oc(a, b, c, d) {
    var f = Xb(d), g = kc(d).P, e = c.W;
    a.push(b, function(h, k, l) {
      return e(h, k, l, g, f);
    });
  }
  function pc(a, b, c, d, f, g) {
    var e = Yb(d, g), h = c.W;
    a.push(b, function(k, l, m) {
      return h(k, l, m, d, e);
    });
  }
  function kc(a) {
    var b = a[hc];
    if (b)
      return b;
    b = ic(a, a[hc] = [], mc, nc, oc, pc);
    gc in a && hc in a && (a.length = 0);
    return b;
  }
  var gc = Symbol();
  function qc(a, b) {
    a[0] = b;
  }
  function rc(a, b, c, d) {
    var f = c.U;
    a[b] = d ? function(g, e, h) {
      return f(g, e, h, d);
    } : f;
  }
  function sc(a, b, c, d, f) {
    var g = c.U, e = ac(d), h = bc(d).P;
    a[b] = function(k, l, m) {
      return g(k, l, m, h, e, f);
    };
  }
  function tc(a, b, c, d, f, g, e) {
    var h = c.U, k = $b(d, f, g);
    a[b] = function(l, m, r) {
      return h(l, m, r, d, k, e);
    };
  }
  function bc(a) {
    var b = a[gc];
    if (b)
      return b;
    b = ic(a, a[gc] = {}, qc, rc, sc, tc);
    gc in a && hc in a && (a.length = 0);
    return b;
  }
  function cc(a, b, c) {
    for (; ob(b) && 4 != b.i; ) {
      var d = b.l, f = c[d];
      if (!f) {
        var g = c[0];
        g && (g = g[d]) && (f = c[d] = ec(g));
      }
      if (!f || !f(b, a, d)) {
        f = b;
        d = a;
        g = f.j;
        pb(f);
        var e = f;
        if (!e.ca) {
          f = e.h.h - g;
          e.h.h = g;
          e = e.h;
          if (0 == f)
            f = db();
          else {
            g = jb(e, f);
            if (e.S && e.m)
              f = e.i.subarray(g, g + f);
            else {
              e = e.i;
              var h = g;
              f = g + f;
              f = h === f ? Ja() : La ? e.slice(h, f) : new Uint8Array(e.subarray(h, f));
            }
            f = 0 == f.length ? db() : new cb(f, Ka);
          }
          (g = d.R) ? g.push(f) : d.R = [f];
        }
      }
    }
    return a;
  }
  function uc(a, b) {
    if (qb.length) {
      var c = qb.pop();
      c.setOptions(void 0);
      hb(c.h, a);
      a = c;
    } else
      a = new nb(a);
    try {
      var d = bc(b);
      return cc(new d.P(), a, d);
    } finally {
      b = a.h, b.i = null, b.m = false, b.l = 0, b.j = 0, b.h = 0, b.S = false, a.l = -1, a.i = -1, 100 > qb.length && qb.push(a);
    }
  }
  function lc(a, b, c) {
    for (var d = c.length, f = 1 == d % 2, g = f ? 1 : 0; g < d; g += 2)
      (0, c[g + 1])(b, a, c[g]);
    Wb(a, b, f ? c[0] : void 0);
  }
  function vc(a, b) {
    var c = new rb();
    lc(a, c, kc(b));
    O(c, c.h.end());
    a = new Uint8Array(c.i);
    b = c.j;
    for (var d = b.length, f = 0, g = 0; g < d; g++) {
      var e = b[g];
      a.set(e, f);
      f += e.length;
    }
    c.j = [a];
    return a;
  }
  function wc(a, b) {
    return { U: a, W: b };
  }
  var Z = wc(function(a, b, c) {
    if (5 !== a.i)
      return false;
    a = a.h;
    var d = a.i, f = a.h, g = d[f];
    var e = d[f + 1];
    var h = d[f + 2];
    d = d[f + 3];
    M(a, a.h + 4);
    e = (g << 0 | e << 8 | h << 16 | d << 24) >>> 0;
    a = 2 * (e >> 31) + 1;
    g = e >>> 23 & 255;
    e &= 8388607;
    V(b, c, 255 == g ? e ? NaN : Infinity * a : 0 == g ? a * Math.pow(2, -149) * e : a * Math.pow(2, g - 150) * (e + Math.pow(2, 23)));
    return true;
  }, function(a, b, c) {
    b = Mb(b, c);
    if (null != b) {
      N(a.h, 8 * c + 5);
      a = a.h;
      var d = +b;
      0 === d ? 0 < 1 / d ? H = K = 0 : (K = 0, H = 2147483648) : isNaN(d) ? (K = 0, H = 2147483647) : (d = (c = 0 > d ? -2147483648 : 0) ? -d : d, 34028234663852886e22 < d ? (K = 0, H = (c | 2139095040) >>> 0) : 11754943508222875e-54 > d ? (d = Math.round(d / Math.pow(2, -149)), K = 0, H = (c | d) >>> 0) : (b = Math.floor(Math.log(d) / Math.LN2), d *= Math.pow(2, -b), d = Math.round(8388608 * d), 16777216 <= d && ++b, K = 0, H = (c | b + 127 << 23 | d & 8388607) >>> 0));
      c = H;
      a.h.push(c >>> 0 & 255);
      a.h.push(c >>> 8 & 255);
      a.h.push(c >>> 16 & 255);
      a.h.push(c >>> 24 & 255);
    }
  }), xc = wc(function(a, b, c) {
    if (0 !== a.i)
      return false;
    var d = a.h, f = 0, g = a = 0, e = d.i, h = d.h;
    do {
      var k = e[h++];
      f |= (k & 127) << g;
      g += 7;
    } while (32 > g && k & 128);
    32 < g && (a |= (k & 127) >> 4);
    for (g = 3; 32 > g && k & 128; g += 7)
      k = e[h++], a |= (k & 127) << g;
    M(
      d,
      h
    );
    if (128 > k) {
      d = f >>> 0;
      k = a >>> 0;
      if (a = k & 2147483648)
        d = ~d + 1 >>> 0, k = ~k >>> 0, 0 == d && (k = k + 1 >>> 0);
      d = 4294967296 * k + (d >>> 0);
    } else
      throw Ta();
    V(b, c, a ? -d : d);
    return true;
  }, function(a, b, c) {
    b = U(b, c);
    null != b && ("string" === typeof b && Qa(b), null != b && (N(a.h, 8 * c), "number" === typeof b ? (a = a.h, Ma(b), mb(a, H, K)) : (c = Qa(b), mb(a.h, c.i, c.h))));
  }), yc = wc(function(a, b, c) {
    if (0 !== a.i)
      return false;
    V(b, c, ib(a.h));
    return true;
  }, function(a, b, c) {
    b = U(b, c);
    if (null != b && null != b)
      if (N(a.h, 8 * c), a = a.h, c = b, 0 <= c)
        N(a, c);
      else {
        for (b = 0; 9 > b; b++)
          a.h.push(c & 127 | 128), c >>= 7;
        a.h.push(1);
      }
  }), zc = wc(function(a, b, c) {
    if (2 !== a.i)
      return false;
    var d = ib(a.h) >>> 0;
    a = a.h;
    var f = jb(a, d);
    a = a.i;
    if (Ya) {
      var g = a, e;
      (e = Xa) || (e = Xa = new TextDecoder("utf-8", { fatal: true }));
      a = f + d;
      g = 0 === f && a === g.length ? g : g.subarray(f, a);
      try {
        var h = e.decode(g);
      } catch (r) {
        if (void 0 === Wa) {
          try {
            e.decode(new Uint8Array([128]));
          } catch (p) {
          }
          try {
            e.decode(new Uint8Array([97])), Wa = true;
          } catch (p) {
            Wa = false;
          }
        }
        !Wa && (Xa = void 0);
        throw r;
      }
    } else {
      h = f;
      d = h + d;
      f = [];
      for (var k = null, l, m; h < d; )
        l = a[h++], 128 > l ? f.push(l) : 224 > l ? h >= d ? L() : (m = a[h++], 194 > l || 128 !== (m & 192) ? (h--, L()) : f.push((l & 31) << 6 | m & 63)) : 240 > l ? h >= d - 1 ? L() : (m = a[h++], 128 !== (m & 192) || 224 === l && 160 > m || 237 === l && 160 <= m || 128 !== ((g = a[h++]) & 192) ? (h--, L()) : f.push((l & 15) << 12 | (m & 63) << 6 | g & 63)) : 244 >= l ? h >= d - 2 ? L() : (m = a[h++], 128 !== (m & 192) || 0 !== (l << 28) + (m - 144) >> 30 || 128 !== ((g = a[h++]) & 192) || 128 !== ((e = a[h++]) & 192) ? (h--, L()) : (l = (l & 7) << 18 | (m & 63) << 12 | (g & 63) << 6 | e & 63, l -= 65536, f.push((l >> 10 & 1023) + 55296, (l & 1023) + 56320))) : L(), 8192 <= f.length && (k = Va(k, f), f.length = 0);
      h = Va(k, f);
    }
    V(b, c, h);
    return true;
  }, function(a, b, c) {
    b = U(b, c);
    if (null != b) {
      var d = false;
      d = void 0 === d ? false : d;
      if ($a) {
        if (d && /(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])/.test(b))
          throw Error("Found an unpaired surrogate");
        b = (Za || (Za = new TextEncoder())).encode(b);
      } else {
        for (var f = 0, g = new Uint8Array(3 * b.length), e = 0; e < b.length; e++) {
          var h = b.charCodeAt(e);
          if (128 > h)
            g[f++] = h;
          else {
            if (2048 > h)
              g[f++] = h >> 6 | 192;
            else {
              if (55296 <= h && 57343 >= h) {
                if (56319 >= h && e < b.length) {
                  var k = b.charCodeAt(++e);
                  if (56320 <= k && 57343 >= k) {
                    h = 1024 * (h - 55296) + k - 56320 + 65536;
                    g[f++] = h >> 18 | 240;
                    g[f++] = h >> 12 & 63 | 128;
                    g[f++] = h >> 6 & 63 | 128;
                    g[f++] = h & 63 | 128;
                    continue;
                  } else
                    e--;
                }
                if (d)
                  throw Error("Found an unpaired surrogate");
                h = 65533;
              }
              g[f++] = h >> 12 | 224;
              g[f++] = h >> 6 & 63 | 128;
            }
            g[f++] = h & 63 | 128;
          }
        }
        b = f === g.length ? g : g.subarray(0, f);
      }
      N(a.h, 8 * c + 2);
      N(a.h, b.length);
      O(a, a.h.end());
      O(a, b);
    }
  }), Ac = wc(function(a, b, c, d, f) {
    if (2 !== a.i)
      return false;
    b = Qb(b, c, d);
    c = a.h.j;
    d = ib(a.h) >>> 0;
    var g = a.h.h + d, e = g - c;
    0 >= e && (a.h.j = g, f(b, a, void 0, void 0, void 0), e = g - a.h.h);
    if (e)
      throw Error("Message parsing ended unexpectedly. Expected to read " + (d + " bytes, instead read " + (d - e) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
    a.h.h = g;
    a.h.j = c;
    return true;
  }, function(a, b, c, d, f) {
    b = Ob(b, d, c);
    if (null != b)
      for (d = 0; d < b.length; d++) {
        var g = a;
        N(g.h, 8 * c + 2);
        var e = g.h.end();
        O(g, e);
        e.push(g.i);
        g = e;
        f(b[d], a);
        e = a;
        var h = g.pop();
        for (h = e.i + e.h.length() - h; 127 < h; )
          g.push(h & 127 | 128), h >>>= 7, e.i++;
        g.push(h);
        e.i++;
      }
  });
  function Bc(a) {
    Y.call(this, a);
  }
  D(Bc, Y);
  var Cc = [Bc, 1, yc, 2, Z, 3, zc, 4, zc];
  function Dc(a) {
    Y.call(this, a, -1, Ec);
  }
  D(Dc, Y);
  Dc.prototype.addClassification = function(a, b) {
    Qb(this, 1, Bc, a, b);
    return this;
  };
  var Ec = [1], Fc = [Dc, 1, Ac, Cc];
  function Gc(a) {
    Y.call(this, a);
  }
  D(Gc, Y);
  var Hc = [Gc, 1, Z, 2, Z, 3, Z, 4, Z, 5, Z];
  function Ic(a) {
    Y.call(this, a, -1, Jc);
  }
  D(Ic, Y);
  var Jc = [1], Kc = [Ic, 1, Ac, Hc];
  function Lc(a) {
    Y.call(this, a);
  }
  D(Lc, Y);
  var Mc = [Lc, 1, Z, 2, Z, 3, Z, 4, Z, 5, Z, 6, xc];
  function Nc(a, b, c) {
    c = a.createShader(0 === c ? a.VERTEX_SHADER : a.FRAGMENT_SHADER);
    a.shaderSource(c, b);
    a.compileShader(c);
    if (!a.getShaderParameter(c, a.COMPILE_STATUS))
      throw Error("Could not compile WebGL shader.\n\n" + a.getShaderInfoLog(c));
    return c;
  }
  function Oc(a) {
    return Ob(a, Bc, 1).map(function(b) {
      return { index: Rb(U(b, 1), 0), qa: X(b, 2), label: null != U(b, 3) ? Rb(U(b, 3), "") : void 0, displayName: null != U(b, 4) ? Rb(U(b, 4), "") : void 0 };
    });
  }
  function Pc(a) {
    return { x: X(a, 1), y: X(a, 2), z: X(a, 3), visibility: null != Mb(a, 4) ? X(a, 4) : void 0 };
  }
  function Qc(a, b) {
    this.i = a;
    this.h = b;
    this.m = 0;
  }
  function Rc(a, b, c) {
    Sc(a, b);
    if ("function" === typeof a.h.canvas.transferToImageBitmap)
      return Promise.resolve(a.h.canvas.transferToImageBitmap());
    if (c)
      return Promise.resolve(a.h.canvas);
    if ("function" === typeof createImageBitmap)
      return createImageBitmap(a.h.canvas);
    void 0 === a.j && (a.j = document.createElement("canvas"));
    return new Promise(function(d) {
      a.j.height = a.h.canvas.height;
      a.j.width = a.h.canvas.width;
      a.j.getContext("2d", {}).drawImage(a.h.canvas, 0, 0, a.h.canvas.width, a.h.canvas.height);
      d(a.j);
    });
  }
  function Sc(a, b) {
    var c = a.h;
    if (void 0 === a.s) {
      var d = Nc(c, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), f = Nc(c, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), g = c.createProgram();
      c.attachShader(g, d);
      c.attachShader(g, f);
      c.linkProgram(g);
      if (!c.getProgramParameter(g, c.LINK_STATUS))
        throw Error("Could not compile WebGL program.\n\n" + c.getProgramInfoLog(g));
      d = a.s = g;
      c.useProgram(d);
      f = c.getUniformLocation(d, "sampler0");
      a.l = { O: c.getAttribLocation(d, "aVertex"), N: c.getAttribLocation(d, "aTex"), ya: f };
      a.v = c.createBuffer();
      c.bindBuffer(c.ARRAY_BUFFER, a.v);
      c.enableVertexAttribArray(a.l.O);
      c.vertexAttribPointer(a.l.O, 2, c.FLOAT, false, 0, 0);
      c.bufferData(c.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), c.STATIC_DRAW);
      c.bindBuffer(c.ARRAY_BUFFER, null);
      a.u = c.createBuffer();
      c.bindBuffer(c.ARRAY_BUFFER, a.u);
      c.enableVertexAttribArray(a.l.N);
      c.vertexAttribPointer(
        a.l.N,
        2,
        c.FLOAT,
        false,
        0,
        0
      );
      c.bufferData(c.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), c.STATIC_DRAW);
      c.bindBuffer(c.ARRAY_BUFFER, null);
      c.uniform1i(f, 0);
    }
    d = a.l;
    c.useProgram(a.s);
    c.canvas.width = b.width;
    c.canvas.height = b.height;
    c.viewport(0, 0, b.width, b.height);
    c.activeTexture(c.TEXTURE0);
    a.i.bindTexture2d(b.glName);
    c.enableVertexAttribArray(d.O);
    c.bindBuffer(c.ARRAY_BUFFER, a.v);
    c.vertexAttribPointer(d.O, 2, c.FLOAT, false, 0, 0);
    c.enableVertexAttribArray(d.N);
    c.bindBuffer(c.ARRAY_BUFFER, a.u);
    c.vertexAttribPointer(
      d.N,
      2,
      c.FLOAT,
      false,
      0,
      0
    );
    c.bindFramebuffer(c.DRAW_FRAMEBUFFER ? c.DRAW_FRAMEBUFFER : c.FRAMEBUFFER, null);
    c.clearColor(0, 0, 0, 0);
    c.clear(c.COLOR_BUFFER_BIT);
    c.colorMask(true, true, true, true);
    c.drawArrays(c.TRIANGLE_FAN, 0, 4);
    c.disableVertexAttribArray(d.O);
    c.disableVertexAttribArray(d.N);
    c.bindBuffer(c.ARRAY_BUFFER, null);
    a.i.bindTexture2d(0);
  }
  function Tc(a) {
    this.h = a;
  }
  var Uc = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
  function Vc(a, b) {
    return b + a;
  }
  function Wc(a, b) {
    window[a] = b;
  }
  function Xc(a) {
    var b = document.createElement("script");
    b.setAttribute("src", a);
    b.setAttribute("crossorigin", "anonymous");
    return new Promise(function(c) {
      b.addEventListener("load", function() {
        c();
      }, false);
      b.addEventListener("error", function() {
        c();
      }, false);
      document.body.appendChild(b);
    });
  }
  function Yc() {
    return F(function(a) {
      switch (a.h) {
        case 1:
          return a.s = 2, E(a, WebAssembly.instantiate(Uc), 4);
        case 4:
          a.h = 3;
          a.s = 0;
          break;
        case 2:
          return a.s = 0, a.l = null, a.return(false);
        case 3:
          return a.return(true);
      }
    });
  }
  function Zc(a) {
    this.h = a;
    this.listeners = {};
    this.l = {};
    this.L = {};
    this.s = {};
    this.v = {};
    this.M = this.u = this.ga = true;
    this.I = Promise.resolve();
    this.fa = "";
    this.D = {};
    this.locateFile = a && a.locateFile || Vc;
    if ("object" === typeof window)
      var b = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
    else if ("undefined" !== typeof location)
      b = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
    else
      throw Error("solutions can only be loaded on a web page or in a web worker");
    this.ha = b;
    if (a.options) {
      b = A(Object.keys(a.options));
      for (var c = b.next(); !c.done; c = b.next()) {
        c = c.value;
        var d = a.options[c].default;
        void 0 !== d && (this.l[c] = "function" === typeof d ? d() : d);
      }
    }
  }
  x = Zc.prototype;
  x.close = function() {
    this.j && this.j.delete();
    return Promise.resolve();
  };
  function $c(a) {
    var b, c, d, f, g, e, h, k, l, m, r;
    return F(function(p) {
      switch (p.h) {
        case 1:
          if (!a.ga)
            return p.return();
          b = void 0 === a.h.files ? [] : "function" === typeof a.h.files ? a.h.files(a.l) : a.h.files;
          return E(p, Yc(), 2);
        case 2:
          c = p.i;
          if ("object" === typeof window)
            return Wc("createMediapipeSolutionsWasm", { locateFile: a.locateFile }), Wc("createMediapipeSolutionsPackedAssets", { locateFile: a.locateFile }), e = b.filter(function(n) {
              return void 0 !== n.data;
            }), h = b.filter(function(n) {
              return void 0 === n.data;
            }), k = Promise.all(e.map(function(n) {
              var q = ad(a, n.url);
              if (void 0 !== n.path) {
                var t = n.path;
                q = q.then(function(w) {
                  a.overrideFile(t, w);
                  return Promise.resolve(w);
                });
              }
              return q;
            })), l = Promise.all(h.map(function(n) {
              return void 0 === n.simd || n.simd && c || !n.simd && !c ? Xc(a.locateFile(n.url, a.ha)) : Promise.resolve();
            })).then(function() {
              var n, q, t;
              return F(function(w) {
                if (1 == w.h)
                  return n = window.createMediapipeSolutionsWasm, q = window.createMediapipeSolutionsPackedAssets, t = a, E(w, n(q), 2);
                t.i = w.i;
                w.h = 0;
              });
            }), m = function() {
              return F(function(n) {
                a.h.graph && a.h.graph.url ? n = E(
                  n,
                  ad(a, a.h.graph.url),
                  0
                ) : (n.h = 0, n = void 0);
                return n;
              });
            }(), E(p, Promise.all([l, k, m]), 7);
          if ("function" !== typeof importScripts)
            throw Error("solutions can only be loaded on a web page or in a web worker");
          d = b.filter(function(n) {
            return void 0 === n.simd || n.simd && c || !n.simd && !c;
          }).map(function(n) {
            return a.locateFile(n.url, a.ha);
          });
          importScripts.apply(null, ea(d));
          f = a;
          return E(p, createMediapipeSolutionsWasm(Module), 6);
        case 6:
          f.i = p.i;
          a.m = new OffscreenCanvas(1, 1);
          a.i.canvas = a.m;
          g = a.i.GL.createContext(a.m, {
            antialias: false,
            alpha: false,
            va: "undefined" !== typeof WebGL2RenderingContext ? 2 : 1
          });
          a.i.GL.makeContextCurrent(g);
          p.h = 4;
          break;
        case 7:
          a.m = document.createElement("canvas");
          r = a.m.getContext("webgl2", {});
          if (!r && (r = a.m.getContext("webgl", {}), !r))
            return console.log("Failed to create WebGL canvas context when passing video frame."), p.return();
          a.K = r;
          a.i.canvas = a.m;
          a.i.createContext(a.m, true, true, {});
        case 4:
          a.j = new a.i.SolutionWasm(), a.ga = false, p.h = 0;
      }
    });
  }
  function bd(a) {
    var b, c, d, f, g, e, h, k;
    return F(function(l) {
      if (1 == l.h) {
        if (a.h.graph && a.h.graph.url && a.fa === a.h.graph.url)
          return l.return();
        a.u = true;
        if (!a.h.graph || !a.h.graph.url) {
          l.h = 2;
          return;
        }
        a.fa = a.h.graph.url;
        return E(l, ad(a, a.h.graph.url), 3);
      }
      2 != l.h && (b = l.i, a.j.loadGraph(b));
      c = A(Object.keys(a.D));
      for (d = c.next(); !d.done; d = c.next())
        f = d.value, a.j.overrideFile(f, a.D[f]);
      a.D = {};
      if (a.h.listeners)
        for (g = A(a.h.listeners), e = g.next(); !e.done; e = g.next())
          h = e.value, cd(a, h);
      k = a.l;
      a.l = {};
      a.setOptions(k);
      l.h = 0;
    });
  }
  x.reset = function() {
    var a = this;
    return F(function(b) {
      a.j && (a.j.reset(), a.s = {}, a.v = {});
      b.h = 0;
    });
  };
  x.setOptions = function(a, b) {
    var c = this;
    if (b = b || this.h.options) {
      for (var d = [], f = [], g = {}, e = A(Object.keys(a)), h = e.next(); !h.done; g = { X: g.X, Y: g.Y }, h = e.next())
        if (h = h.value, !(h in this.l && this.l[h] === a[h])) {
          this.l[h] = a[h];
          var k = b[h];
          void 0 !== k && (k.onChange && (g.X = k.onChange, g.Y = a[h], d.push(function(l) {
            return function() {
              var m;
              return F(function(r) {
                if (1 == r.h)
                  return E(r, l.X(l.Y), 2);
                m = r.i;
                true === m && (c.u = true);
                r.h = 0;
              });
            };
          }(g))), k.graphOptionXref && (h = Object.assign(
            {},
            { calculatorName: "", calculatorIndex: 0 },
            k.graphOptionXref,
            { valueNumber: 1 === k.type ? a[h] : 0, valueBoolean: 0 === k.type ? a[h] : false, valueString: 2 === k.type ? a[h] : "" }
          ), f.push(h)));
        }
      if (0 !== d.length || 0 !== f.length)
        this.u = true, this.H = (void 0 === this.H ? [] : this.H).concat(f), this.F = (void 0 === this.F ? [] : this.F).concat(d);
    }
  };
  function dd(a) {
    var b, c, d, f, g, e, h;
    return F(function(k) {
      switch (k.h) {
        case 1:
          if (!a.u)
            return k.return();
          if (!a.F) {
            k.h = 2;
            break;
          }
          b = A(a.F);
          c = b.next();
        case 3:
          if (c.done) {
            k.h = 5;
            break;
          }
          d = c.value;
          return E(k, d(), 4);
        case 4:
          c = b.next();
          k.h = 3;
          break;
        case 5:
          a.F = void 0;
        case 2:
          if (a.H) {
            f = new a.i.GraphOptionChangeRequestList();
            g = A(a.H);
            for (e = g.next(); !e.done; e = g.next())
              h = e.value, f.push_back(h);
            a.j.changeOptions(f);
            f.delete();
            a.H = void 0;
          }
          a.u = false;
          k.h = 0;
      }
    });
  }
  x.initialize = function() {
    var a = this;
    return F(function(b) {
      return 1 == b.h ? E(b, $c(a), 2) : 3 != b.h ? E(b, bd(a), 3) : E(b, dd(a), 0);
    });
  };
  function ad(a, b) {
    var c, d;
    return F(function(f) {
      if (b in a.L)
        return f.return(a.L[b]);
      c = a.locateFile(b, "");
      d = fetch(c).then(function(g) {
        return g.arrayBuffer();
      });
      a.L[b] = d;
      return f.return(d);
    });
  }
  x.overrideFile = function(a, b) {
    this.j ? this.j.overrideFile(a, b) : this.D[a] = b;
  };
  x.clearOverriddenFiles = function() {
    this.D = {};
    this.j && this.j.clearOverriddenFiles();
  };
  x.send = function(a, b) {
    var c = this, d, f, g, e, h, k, l, m, r;
    return F(function(p) {
      switch (p.h) {
        case 1:
          if (!c.h.inputs)
            return p.return();
          d = 1e3 * (void 0 === b || null === b ? performance.now() : b);
          return E(p, c.I, 2);
        case 2:
          return E(p, c.initialize(), 3);
        case 3:
          f = new c.i.PacketDataList();
          g = A(Object.keys(a));
          for (e = g.next(); !e.done; e = g.next())
            if (h = e.value, k = c.h.inputs[h]) {
              a: {
                var n = a[h];
                switch (k.type) {
                  case "video":
                    var q = c.s[k.stream];
                    q || (q = new Qc(c.i, c.K), c.s[k.stream] = q);
                    0 === q.m && (q.m = q.i.createTexture());
                    if ("undefined" !== typeof HTMLVideoElement && n instanceof HTMLVideoElement) {
                      var t = n.videoWidth;
                      var w = n.videoHeight;
                    } else
                      "undefined" !== typeof HTMLImageElement && n instanceof HTMLImageElement ? (t = n.naturalWidth, w = n.naturalHeight) : (t = n.width, w = n.height);
                    w = { glName: q.m, width: t, height: w };
                    t = q.h;
                    t.canvas.width = w.width;
                    t.canvas.height = w.height;
                    t.activeTexture(t.TEXTURE0);
                    q.i.bindTexture2d(q.m);
                    t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, n);
                    q.i.bindTexture2d(0);
                    q = w;
                    break a;
                  case "detections":
                    q = c.s[k.stream];
                    q || (q = new Tc(c.i), c.s[k.stream] = q);
                    q.data || (q.data = new q.h.DetectionListData());
                    q.data.reset(n.length);
                    for (w = 0; w < n.length; ++w) {
                      t = n[w];
                      var v = q.data, B = v.setBoundingBox, J = w;
                      var I = t.la;
                      var u = new Lc();
                      W(u, 1, I.sa);
                      W(u, 2, I.ta);
                      W(u, 3, I.height);
                      W(u, 4, I.width);
                      W(u, 5, I.rotation);
                      V(u, 6, I.pa);
                      I = vc(u, Mc);
                      B.call(v, J, I);
                      if (t.ea)
                        for (v = 0; v < t.ea.length; ++v) {
                          u = t.ea[v];
                          B = q.data;
                          J = B.addNormalizedLandmark;
                          I = w;
                          u = Object.assign({}, u, { visibility: u.visibility ? u.visibility : 0 });
                          var C = new Gc();
                          W(C, 1, u.x);
                          W(C, 2, u.y);
                          W(C, 3, u.z);
                          u.visibility && W(C, 4, u.visibility);
                          u = vc(
                            C,
                            Hc
                          );
                          J.call(B, I, u);
                        }
                      if (t.ba)
                        for (v = 0; v < t.ba.length; ++v)
                          B = q.data, J = B.addClassification, I = w, u = t.ba[v], C = new Bc(), W(C, 2, u.qa), u.index && V(C, 1, u.index), u.label && V(C, 3, u.label), u.displayName && V(C, 4, u.displayName), u = vc(C, Cc), J.call(B, I, u);
                    }
                    q = q.data;
                    break a;
                  default:
                    q = {};
                }
              }
              l = q;
              m = k.stream;
              switch (k.type) {
                case "video":
                  f.pushTexture2d(Object.assign({}, l, { stream: m, timestamp: d }));
                  break;
                case "detections":
                  r = l;
                  r.stream = m;
                  r.timestamp = d;
                  f.pushDetectionList(r);
                  break;
                default:
                  throw Error("Unknown input config type: '" + k.type + "'");
              }
            }
          c.j.send(f);
          return E(p, c.I, 4);
        case 4:
          f.delete(), p.h = 0;
      }
    });
  };
  function ed(a, b, c) {
    var d, f, g, e, h, k, l, m, r, p, n, q, t, w;
    return F(function(v) {
      switch (v.h) {
        case 1:
          if (!c)
            return v.return(b);
          d = {};
          f = 0;
          g = A(Object.keys(c));
          for (e = g.next(); !e.done; e = g.next())
            h = e.value, k = c[h], "string" !== typeof k && "texture" === k.type && void 0 !== b[k.stream] && ++f;
          1 < f && (a.M = false);
          l = A(Object.keys(c));
          e = l.next();
        case 2:
          if (e.done) {
            v.h = 4;
            break;
          }
          m = e.value;
          r = c[m];
          if ("string" === typeof r)
            return t = d, w = m, E(v, fd(a, m, b[r]), 14);
          p = b[r.stream];
          if ("detection_list" === r.type) {
            if (p) {
              var B = p.getRectList();
              for (var J = p.getLandmarksList(), I = p.getClassificationsList(), u = [], C = 0; C < B.size(); ++C) {
                var T = uc(B.get(C), Mc), id = X(T, 1), jd = X(T, 2), kd = X(T, 3), ld = X(T, 4), md = X(T, 5, 0), xa = void 0;
                xa = void 0 === xa ? 0 : xa;
                T = { la: { sa: id, ta: jd, height: kd, width: ld, rotation: md, pa: Rb(U(T, 6), xa) }, ea: Ob(uc(J.get(C), Kc), Gc, 1).map(Pc), ba: Oc(uc(I.get(C), Fc)) };
                u.push(T);
              }
              B = u;
            } else
              B = [];
            d[m] = B;
            v.h = 7;
            break;
          }
          if ("proto_list" === r.type) {
            if (p) {
              B = Array(p.size());
              for (J = 0; J < p.size(); J++)
                B[J] = p.get(J);
              p.delete();
            } else
              B = [];
            d[m] = B;
            v.h = 7;
            break;
          }
          if (void 0 === p) {
            v.h = 3;
            break;
          }
          if ("float_list" === r.type) {
            d[m] = p;
            v.h = 7;
            break;
          }
          if ("proto" === r.type) {
            d[m] = p;
            v.h = 7;
            break;
          }
          if ("texture" !== r.type)
            throw Error("Unknown output config type: '" + r.type + "'");
          n = a.v[m];
          n || (n = new Qc(a.i, a.K), a.v[m] = n);
          return E(v, Rc(n, p, a.M), 13);
        case 13:
          q = v.i, d[m] = q;
        case 7:
          r.transform && d[m] && (d[m] = r.transform(d[m]));
          v.h = 3;
          break;
        case 14:
          t[w] = v.i;
        case 3:
          e = l.next();
          v.h = 2;
          break;
        case 4:
          return v.return(d);
      }
    });
  }
  function fd(a, b, c) {
    var d;
    return F(function(f) {
      return "number" === typeof c || c instanceof Uint8Array || c instanceof a.i.Uint8BlobList ? f.return(c) : c instanceof a.i.Texture2dDataOut ? (d = a.v[b], d || (d = new Qc(a.i, a.K), a.v[b] = d), f.return(Rc(d, c, a.M))) : f.return(void 0);
    });
  }
  function cd(a, b) {
    for (var c = b.name || "$", d = [].concat(ea(b.wants)), f = new a.i.StringList(), g = A(b.wants), e = g.next(); !e.done; e = g.next())
      f.push_back(e.value);
    g = a.i.PacketListener.implement({ onResults: function(h) {
      for (var k = {}, l = 0; l < b.wants.length; ++l)
        k[d[l]] = h.get(l);
      var m = a.listeners[c];
      m && (a.I = ed(a, k, b.outs).then(function(r) {
        r = m(r);
        for (var p = 0; p < b.wants.length; ++p) {
          var n = k[d[p]];
          "object" === typeof n && n.hasOwnProperty && n.hasOwnProperty("delete") && n.delete();
        }
        r && (a.I = r);
      }));
    } });
    a.j.attachMultiListener(f, g);
    f.delete();
  }
  x.onResults = function(a, b) {
    this.listeners[b || "$"] = a;
  };
  za("Solution", Zc);
  za("OptionType", { BOOL: 0, NUMBER: 1, ua: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
  function gd(a) {
    void 0 === a && (a = 0);
    switch (a) {
      case 1:
        return "selfie_segmentation_landscape.tflite";
      default:
        return "selfie_segmentation.tflite";
    }
  }
  function hd(a) {
    var b = this;
    a = a || {};
    this.h = new Zc({ locateFile: a.locateFile, files: function(c) {
      return [{ simd: true, url: "selfie_segmentation_solution_simd_wasm_bin.js" }, { simd: false, url: "selfie_segmentation_solution_wasm_bin.js" }, { data: true, url: gd(c.modelSelection) }];
    }, graph: { url: "selfie_segmentation.binarypb" }, listeners: [{ wants: ["segmentation_mask", "image_transformed"], outs: { image: { type: "texture", stream: "image_transformed" }, segmentationMask: { type: "texture", stream: "segmentation_mask" } } }], inputs: { image: {
      type: "video",
      stream: "input_frames_gpu"
    } }, options: { useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: "object" !== typeof window || void 0 === window.navigator ? false : "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document }, selfieMode: { type: 0, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } }, modelSelection: {
      type: 1,
      graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorModelSelection", fieldName: "int_value" },
      onChange: function(c) {
        var d, f, g;
        return F(function(e) {
          if (1 == e.h)
            return d = gd(c), f = "third_party/mediapipe/modules/selfie_segmentation/" + d, E(e, ad(b.h, d), 2);
          g = e.i;
          b.h.overrideFile(f, g);
          return e.return(true);
        });
      }
    } } });
  }
  x = hd.prototype;
  x.close = function() {
    this.h.close();
    return Promise.resolve();
  };
  x.onResults = function(a) {
    this.h.onResults(a);
  };
  x.initialize = function() {
    var a = this;
    return F(function(b) {
      return E(b, a.h.initialize(), 0);
    });
  };
  x.reset = function() {
    this.h.reset();
  };
  x.send = function(a) {
    var b = this;
    return F(function(c) {
      return E(c, b.h.send(a), 0);
    });
  };
  x.setOptions = function(a) {
    this.h.setOptions(a);
  };
  za("SelfieSegmentation", hd);
  za("VERSION", "0.1.1671057942");
}).call(commonjsGlobal);
var SelfieSegmentation_1 = SelfieSegmentation;
const createSelfieSegmentation = (options = {
  modelSelection: 1
}) => {
  const ss = new SelfieSegmentation_1({ locateFile: (file) => `https://cdn.dyte.in/@mediapipe/selfie_segmentation/${file}` });
  ss.setOptions(options);
  return ss;
};
const loadImage = (src) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = () => resolve(img);
  img.onerror = reject;
  img.src = src;
  img.crossOrigin = "anonymous";
});
const _ImageBackgroundTransformer = class extends BackgroundTransformer {
  constructor(selfieSegmentation) {
    super();
    __privateAdd(this, _selfieSegmentation, void 0);
    __privateAdd(this, _newCanvas, void 0);
    __privateAdd(this, _context, void 0);
    __privateSet(this, _selfieSegmentation, selfieSegmentation);
    __privateSet(this, _newCanvas, document.createElement("canvas"));
    __privateSet(this, _context, __privateGet(this, _newCanvas).getContext("2d"));
  }
  static async init() {
    const selfieSegmentation = createSelfieSegmentation();
    await selfieSegmentation.initialize();
    return new _ImageBackgroundTransformer(selfieSegmentation);
  }
  async createStaticBackgroundImageVideoMiddleware(backgroundImageUrl) {
    const backgroundImage = await loadImage(backgroundImageUrl);
    let previousSelfieSegmentationResults;
    return () => {
      __privateGet(this, _selfieSegmentation).onResults((results) => {
        previousSelfieSegmentationResults = results;
      });
      return async (canvas, canvasCtx) => {
        __privateGet(this, _newCanvas).width = canvas.width;
        __privateGet(this, _newCanvas).height = canvas.height;
        __privateGet(this, _context).drawImage(canvas, 0, 0);
        __privateGet(this, _selfieSegmentation).send({ image: __privateGet(this, _newCanvas) });
        if (previousSelfieSegmentationResults) {
          canvasCtx.save();
          canvasCtx.clearRect(0, 0, canvas.width, canvas.height);
          canvasCtx.globalCompositeOperation = "copy";
          canvasCtx.filter = "blur(2px)";
          canvasCtx.drawImage(
            previousSelfieSegmentationResults.segmentationMask,
            0,
            0,
            canvas.width,
            canvas.height
          );
          canvasCtx.globalCompositeOperation = "source-in";
          canvasCtx.filter = "none";
          canvasCtx.drawImage(
            previousSelfieSegmentationResults.image,
            0,
            0,
            canvas.width,
            canvas.height
          );
          canvasCtx.globalCompositeOperation = "destination-atop";
          canvasCtx.drawImage(backgroundImage, 0, 0, canvas.width, canvas.height);
          canvasCtx.restore();
        }
      };
    };
  }
};
let ImageBackgroundTransformer = _ImageBackgroundTransformer;
_selfieSegmentation = new WeakMap();
_newCanvas = new WeakMap();
_context = new WeakMap();
const _SimpleBackgroundTransformer = class extends BackgroundTransformer {
  constructor(selfieSegmentation) {
    super();
    __privateAdd(this, _selfieSegmentation2, void 0);
    __privateAdd(this, _newCanvas2, void 0);
    __privateAdd(this, _context2, void 0);
    __privateSet(this, _selfieSegmentation2, selfieSegmentation);
    __privateSet(this, _newCanvas2, document.createElement("canvas"));
    __privateSet(this, _context2, __privateGet(this, _newCanvas2).getContext("2d"));
  }
  static async init() {
    const selfieSegmentation = createSelfieSegmentation();
    await selfieSegmentation.initialize();
    return new _SimpleBackgroundTransformer(selfieSegmentation);
  }
  createBackgroundBlurVideoMiddleware(blurLength) {
    let previousSelfieSegmentationResults;
    if (blurLength < 0)
      throw Error(`Blur Length must be 0 or more, received: ${blurLength}`);
    return () => {
      __privateGet(this, _selfieSegmentation2).onResults((results) => {
        previousSelfieSegmentationResults = results;
      });
      return async (canvas, canvasCtx) => {
        __privateGet(this, _newCanvas2).width = canvas.width;
        __privateGet(this, _newCanvas2).height = canvas.height;
        __privateGet(this, _context2).drawImage(canvas, 0, 0);
        __privateGet(this, _selfieSegmentation2).send({ image: __privateGet(this, _newCanvas2) });
        if (previousSelfieSegmentationResults) {
          canvasCtx.save();
          canvasCtx.drawImage(
            previousSelfieSegmentationResults.image,
            0,
            0,
            canvas.width,
            canvas.height
          );
          canvasCtx.globalCompositeOperation = "destination-atop";
          canvasCtx.drawImage(
            previousSelfieSegmentationResults.segmentationMask,
            0,
            0,
            canvas.width,
            canvas.height
          );
          canvasCtx.filter = `blur(${blurLength}px)`;
          canvasCtx.globalCompositeOperation = "destination-over";
          canvasCtx.drawImage(
            previousSelfieSegmentationResults.image,
            0,
            0,
            canvas.width,
            canvas.height
          );
          canvasCtx.restore();
        }
      };
    };
  }
};
let SimpleBackgroundTransformer = _SimpleBackgroundTransformer;
_selfieSegmentation2 = new WeakMap();
_newCanvas2 = new WeakMap();
_context2 = new WeakMap();
const _DyteVideoBackgroundTransformer = class {
  constructor(imageBackgroundTransformer, simpleBackgroundTransformer) {
    __privateAdd(this, _imageBackgroundTransformer, void 0);
    __privateAdd(this, _simpleBackgroundTrasnformer, void 0);
    __privateSet(this, _imageBackgroundTransformer, imageBackgroundTransformer);
    __privateSet(this, _simpleBackgroundTrasnformer, simpleBackgroundTransformer);
  }
  static async init() {
    if (!this.isSupported()) {
      console.error("Initialising it in an unsupported environment, the middleware might not work");
    }
    window.addEventListener("error", (event) => {
      var _a;
      if (!((_a = event.filename) == null ? void 0 : _a.includes("localhost")) && event.lineno !== 0) {
        console.error("DyteVideoBackgroundTransformer::UnhandledError", event.error);
      }
    });
    window.addEventListener("unhandledrejection", (error) => {
      console.error("DyteVideoBackgroundTransformer::UnhandledRejection", error.reason);
    });
    return new _DyteVideoBackgroundTransformer(
      await ImageBackgroundTransformer.init(),
      await SimpleBackgroundTransformer.init()
    );
  }
  static isSupported() {
    var _a;
    let isMiddlewareSupported = false;
    try {
      const browser = Bowser.getParser(window.navigator.userAgent);
      const dummyCanvas = document.createElement("canvas");
      const context = dummyCanvas.getContext("webgl2", {}) || dummyCanvas.getContext("webgl", {});
      const browserMajorVersion = +((_a = browser.getBrowserVersion()) == null ? void 0 : _a.split(".")[0]);
      if (!context || browser.getOSName() === "iOS" || browser.getBrowserName() === "Safari" && browserMajorVersion < 17) {
        return false;
      }
      isMiddlewareSupported = true;
    } catch {
      isMiddlewareSupported = false;
    }
    return isMiddlewareSupported;
  }
  async createStaticBackgroundVideoMiddleware(staticBackgroundImageURL) {
    const staticBackgroundVideoMiddleware = await __privateGet(this, _imageBackgroundTransformer).createStaticBackgroundImageVideoMiddleware(staticBackgroundImageURL);
    return staticBackgroundVideoMiddleware;
  }
  async createBackgroundBlurVideoMiddleware(blurLength = 4) {
    return __privateGet(this, _simpleBackgroundTrasnformer).createBackgroundBlurVideoMiddleware(blurLength);
  }
};
let DyteVideoBackgroundTransformer = _DyteVideoBackgroundTransformer;
_imageBackgroundTransformer = new WeakMap();
_simpleBackgroundTrasnformer = new WeakMap();
export { DyteVideoBackgroundTransformer as default };
